<template>
	<div class="infor fl">
		<AllHeader :label="lable" :ischage="ischage" :sublabel="sublabel" :subtitle="subtitle" :year="year"
			@getvalue="getvalue"  v-if="step == 1" />
		<div v-if="step == 0">
		            <div style="position:relative;" class="topnavs">

        		            <el-radio-group v-model="activerole" @input="handlerole" >
                                <el-radio-button label="main"  v-if="activerole != 'leader'">主审</el-radio-button>
                                <el-radio-button label="second"  v-if="activerole != 'leader'" >副审</el-radio-button>
                                <el-radio-button label="leader" v-if="activerole == 'leader'">组长</el-radio-button>
                             </el-radio-group>
                        <div style="display:flex;justify-content:center;align-items:center">
                            <span>{{bname}}</span>
                            <div class="infor-t-r" @click="toBatch" style="margin-left:20px; cursor: pointer;">
                    			<span>返回批次</span>
                    		</div>
                        </div>
    		            
    		        </div>
    		        <div style="position:relative">
    		            <el-form ref="queryForm" size="small" :inline="true" label-width="68px" style="margin-top:20px;text-align:left;">
                        <el-form-item  prop="wtype">
                            <el-select style="width: 100px" v-model="wtype" placeholder="工法类型" clearable>
                                <el-option key="1" label="房屋建筑工程" value="房屋建筑工程" />
                                <el-option key="2" label="土木工程" value="土木工程" />
                                <el-option key="3" label="工业安装工程" value="工业安装工程" />
                            </el-select>
                        </el-form-item>
                        <!--<el-form-item  prop="dates">-->
                        <!--         <el-date-picker-->
                        <!--          v-model="dates"-->
                        <!--          type="daterange"-->
                        <!--          range-separator="至"-->
                        <!--          start-placeholder="开始日期"-->
                        <!--          end-placeholder="结束日期">-->
                        <!--        </el-date-picker>-->
                        <!--    </el-form-item>-->
                        <el-form-item  v-if="activerole == 'leader'"  prop="astatus">
                            <el-select style="width: 100px" v-model="astatus" placeholder="状态" clearable>
                                <el-option key="1" label="2个通过" value="1" />
                                <el-option key="2" label="2个不通过" value="2" />
                                <el-option key="3" label="1个通过" value="3" />
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item prop="keyword">
                            <el-input style="width: 250px"
                                      v-model="keyword"
                                placeholder="请输入申报单位名称"
                                clearable/>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
                        </el-form-item>
                    </el-form>
    		        </div>
              <div v-if="activerole =='leader' && cstatus == 0" style="margin-bottom: 12px; display: flex; align-items:center;justify-content: flex-end; gap: 8px;margin-bottom:10px;">
                  <el-button type="success" size="mini" @click="exportLeaderSummary">
                    汇总表下载
                  </el-button>
                  <el-button type="success" size="mini" :disabled="selected_log_ids.length === 0" @click="batchExportSelectedScore">
                    评审表下载
                  </el-button>
                  <el-button type="primary"  size="mini" :disabled="selected_log_ids.length === 0" @click="handleBatchChecked('approve')">
                    批量通过
                  </el-button>
                </div>      
				<el-table :key="activerole + '-' + cstatus"
                      :data="formlist"
                      v-loading="loading"
                class="gf-review-table"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%; margin-top: 10px" :cell-style="{'text-align':'center'}" @selection-change="handleSelectionChange" @filter-change="handleStatusFilterChange">
			      <el-table-column type="selection" width="55" v-if="activerole=='leader'" :selectable="canLeaderReview">  </el-table-column>

				<el-table-column label="序号" min-width="80">
				    <template slot-scope="scope">
				        <div v-if="activerole !== 'leader' && scope.row.sms_fail_info"
				             class="sms-fail-badge"
				             @click="openSmsFailDialog(scope.row.sms_fail_info)">通知失败</div>
				        <div>{{ scope.row.no }}</div>
				    </template>
				</el-table-column>

				<!-- 组长：状态列 -->
				<el-table-column label="状态" min-width="90" v-if="activerole === 'leader'"
                    column-key="reviewStatus"
                    :filters="reviewStatusFilters"
                    :filter-multiple="false"
                    :filtered-value="tableColumnFilters.reviewStatus || []"
                    :filter-method="filterLeaderStatus">
				    <template slot-scope="scope">
				        <span :style="{color: getLeaderPrimaryStatusColor(scope.row), fontWeight: 500}">
				            {{ getLeaderPrimaryStatusText(scope.row) }}
				        </span>
				    </template>
				</el-table-column>
				<!-- 主审/副审：状态列 -->
				<el-table-column label="状态" min-width="90" v-if="activerole !== 'leader'"
                    column-key="reviewStatus"
                    :filters="reviewStatusFilters"
                    :filter-multiple="false"
                    :filtered-value="tableColumnFilters.reviewStatus || []"
                    :filter-method="filterLeaderStatus">
				    <template slot-scope="scope">
				        <span :style="{color: getExpertReviewStatusColor(scope.row), fontWeight: 500}">
				            {{ getExpertReviewStatusText(scope.row) }}
				        </span>
				    </template>
				</el-table-column>

				<el-table-column prop="user.name" label="单位" min-width="100"></el-table-column>
				<el-table-column prop="content.info.type_of_work" label="工法类型" min-width="100"
                    v-if="activerole === 'leader'"
                    column-key="wtype"
                    :filters="leaderWtypeFilters"
                    :filter-multiple="false"
                    :filtered-value="tableColumnFilters.wtype || []"
                    :filter-method="filterWtype"></el-table-column>
				<el-table-column prop="content.info.type_of_work" label="工法类型" min-width="100" v-else></el-table-column>
				<el-table-column prop="content.info.name" label="工法名称" min-width="100"></el-table-column>
				<el-table-column label="工法完成人" min-width="100">
				    <template slot-scope="scope">
                          <span><block v-for="(author,index) in scope.row.content.info.author_names">{{ author.name }}<block v-if="index + 1 < scope.row.content.info.author_names.length">、</block></block></span>
                    </template>
				</el-table-column>

				<!-- 组长：主审 + 主审结果 + 副审 + 副审结果 -->
				<el-table-column label="主审" min-width="80" v-if="activerole === 'leader'">
				    <template slot-scope="scope">
                          {{ scope.row.mainexpert && scope.row.mainexpert.expert ? scope.row.mainexpert.expert.name : '-' }}
                    </template>
				</el-table-column>
				<el-table-column label="结果" min-width="80" v-if="activerole === 'leader'"
                    column-key="mainResult"
                    :filters="leaderResultFilters"
                    :filter-multiple="false"
                    :filtered-value="tableColumnFilters.mainResult || []"
                    :filter-method="filterMainResult">
				    <template slot-scope="scope">
						  <span v-if="scope.row.mainexpert && Number(scope.row.mainexpert.status) === 1" style="color:#67C23A;">推荐</span>
						  <span v-else-if="scope.row.mainexpert && isExpertRecordReturned(scope.row.mainexpert)" style="color:#595959;">退回</span>
						  <span v-else-if="scope.row.mainexpert && Number(scope.row.mainexpert.status) === 0" style="color:#F56C6C;">不推荐</span>
                          <span v-else>-</span>
                    </template>
				</el-table-column>
				<el-table-column label="副审" min-width="80" v-if="activerole === 'leader'">
				    <template slot-scope="scope">
                          {{ scope.row.reexpert && scope.row.reexpert.expert ? scope.row.reexpert.expert.name : '-' }}
                    </template>
				</el-table-column>
				<el-table-column label="结果" min-width="80" v-if="activerole === 'leader'"
                    column-key="secondResult"
                    :filters="leaderResultFilters"
                    :filter-multiple="false"
                    :filtered-value="tableColumnFilters.secondResult || []"
                    :filter-method="filterSecondResult">
				    <template slot-scope="scope">
						  <span v-if="scope.row.reexpert && Number(scope.row.reexpert.status) === 1" style="color:#67C23A;">推荐</span>
						  <span v-else-if="scope.row.reexpert && isExpertRecordReturned(scope.row.reexpert)" style="color:#595959;">退回</span>
						  <span v-else-if="scope.row.reexpert && Number(scope.row.reexpert.status) === 0" style="color:#F56C6C;">不推荐</span>
                          <span v-else>-</span>
                    </template>
				</el-table-column>

				<el-table-column label="结果" min-width="80" v-if="activerole === 'leader'">
				    <template slot-scope="scope">
					          <span v-if="scope.row.leader && Number(scope.row.leader.status) === 1" style="color:#67C23A;">推荐</span>
					          <span v-else-if="scope.row.leader && isExpertRecordReturned(scope.row.leader)" style="color:#595959;">退回</span>
					          <span v-else-if="scope.row.leader && Number(scope.row.leader.status) === 0" style="color:#F56C6C;">不推荐</span>
				          <span v-else>-</span>
				    </template>
				</el-table-column>
				<el-table-column prop="created_at" label="提交时间" min-width="120"></el-table-column>

				<el-table-column min-width="110" label="操作" fixed="right">
					<template slot-scope="scope">
						<!-- 组长操作 -->
						<template v-if="activerole === 'leader'">
							<!-- 待中审：审核 + 退回初审 -->
							<template v-if="canLeaderReview(scope.row) && cstatus == 0">
								<el-button size="mini" type="primary" @click="toDetail(scope.row, scope.$index)">审核</el-button><br/>
								<el-button size="mini" @click="openReturnInitialDialog(scope.row)" style="margin-top:6px;">退回初审</el-button>
							</template>
							<!-- 整个审核流程完成（status=4）：查看申请详情 -->
							<el-button v-else-if="isReviewCompleted(scope.row)" size="mini" type="default" @click="openApplicationDetail(scope.row)">查看</el-button>
							<!-- 已退回企业（status=7）：待企业修改 -->
							<span v-else-if="Number(scope.row.status) === 7" style="color:#595959;font-size:12px;">待企业修改</span>
							<!-- 超时终止（status=9）：查阅 -->
							<el-button v-else-if="isTimeoutTerminated(scope.row)" size="mini" @click="toDetail(scope.row,scope.$index)">查阅</el-button>
							<!-- 初审中 / 待初审：数据审核中 -->
							<span v-else style="color:#909399;font-size:12px;">数据审核中</span>
						</template>
						<!-- 主审 / 副审操作 -->
						<template v-else>
							<span v-if="isReturnedRow(scope.row)" style="color:#595959;font-size:12px;">等待企业修改</span>
							<el-button v-else-if="cstatus == 1 || isTimeoutTerminated(scope.row)" @click="toDetail(scope.row,scope.$index,'review')" size="mini" type="default">查阅</el-button>
							<template v-else-if="cstatus == 0">
								<el-button v-if="canExpertReview(scope.row)" size="mini" type="primary" @click="toDetail(scope.row, scope.$index,'review')" style="margin-bottom:4px;">审核</el-button>
								<el-button v-else size="mini" type="default" @click="toDetail(scope.row, scope.$index,'review')">查阅</el-button>
							</template>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<Pagetion :total="total" @getpageValue="getpageValue" class="pos-page" />
            <!--<el-dialog title="导出" :visible.sync="download" width="500px">-->
            <!--    <div class="form_right" style="width:400px">-->
            <!--        <div class="form_1">-->
            <!--            <div class="form_box_content">-->
            <!--                <div class="flex">-->
            <!--                    <div class="my_form2">-->
            <!--                        <div class="form_title" style="">日期</div>-->
            <!--                        <div class="form_content">-->
            <!--                            <el-date-picker-->
            <!--                                v-model="timeRange"-->
            <!--                                type="daterange"-->
            <!--                                range-separator="至"-->
            <!--                                start-placeholder="开始日期"-->
            <!--                                end-placeholder="结束日期">-->
            <!--                            </el-date-picker>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--        </div>-->
            <!--    </div>-->
            <!--    <span slot="footer" class="dialog-footer">-->
            <!--        <el-button type="primary" @click="exportInfo">导 出</el-button>-->
            <!--      </span>-->
            <!--</el-dialog>-->
		</div>
		<div v-if="step==1">

			<!-- ====== 主审/副审 审核视图 ====== -->
			<template v-if="activerole !== 'leader'">
				<!-- 顶部单行 table -->
				<el-table v-if="temformlist.length"
					:data="temformlist"
					:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
					style="width:100%;margin-bottom:0;" :cell-style="{'text-align':'center'}">
					<el-table-column prop="no" label="序号" min-width="60"></el-table-column>
					<el-table-column label="单位" min-width="120">
						<template slot-scope="scope">{{scope.row.content && scope.row.content.info ? scope.row.content.info.unit : scope.row.user && scope.row.user.name}}</template>
					</el-table-column>
					<el-table-column prop="content.info.type_of_work" label="工法类型" min-width="100"></el-table-column>
					<el-table-column prop="content.info.name" label="工法名称" min-width="100"></el-table-column>
					<el-table-column label="工法完成人" min-width="100">
						<template slot-scope="scope">
							<block v-for="(author,index) in scope.row.content.info.author_names">{{author.name}}<block v-if="index+1 < scope.row.content.info.author_names.length">、</block></block>
						</template>
					</el-table-column>
					<el-table-column prop="created_at" label="提交时间" min-width="130"></el-table-column>
					<el-table-column label="状态" min-width="90">
						<template slot-scope="scope">
							<span :style="{color: getExpertReviewStatusColor(scope.row), fontWeight:500}">{{getExpertReviewStatusText(scope.row)}}</span>
						</template>
					</el-table-column>
				</el-table>

				<!-- 三个 Tab + 右侧操作按钮 -->
				<div style=" align-items:center;justify-content:space-between;margin-top:10px;">
					<el-tabs v-model="activeName" tab-position="top" style="flex:1;margin-bottom:0;">
						<el-tab-pane label="材料审核" name="first"></el-tab-pane>
						<el-tab-pane label="审核意见" name="three"></el-tab-pane>
						<el-tab-pane label="审核日志" name="four"></el-tab-pane>
					</el-tabs>
				</div>

				<!-- Tab 内容区 -->
				<div v-show="activeName === 'first'" style="padding-top:10px;">
					<!-- 上次退回原因提示 -->
						<div v-if="last_rejection_reason" class="last_rejection_reason" style="margin-bottom:12px;">
							<div>退回时间：{{last_updated_at}}</div>
							<div>退回理由：{{last_rejection_reason}}</div>
						</div>
						<div class="gf-return-hint">
							若当前材料内容有误、需修改后重新审核，可退回至企业处理，仅限退回一次。<br />
							操作步骤：点击【退回修改】→ 选中需退回条目 → 填写退回原因 → 提交完成退回
						</div>
						<div v-if="cstatus == 0 && temformlist.length && canExpertReview(temformlist[0]) && showExpertAuditButtons" style="text-align:right;margin-bottom:14px;">
							<template v-if="inRejectMode">
								<el-button size="mini" @click="cancelRejectMode">取消</el-button>
								<el-button type="primary" class="tuibtn" size="mini" @click="confirmInlineReject">确认退回</el-button>
							</template>
							<template v-else-if="canUseReject(temformlist[0])">
								<el-button size="mini" class="tuibtn" @click="enterRejectMode">退回修改</el-button>
							</template>
						</div>
						<!-- 工法基本信息（非退回模式显示） -->
						<div v-if="!inRejectMode" class="form_right" style="border:1px solid #DDD;width:auto;margin-bottom:16px;">
							<div class="form_1" style="padding:0;margin:0;">
								<div class="form_box_content binfobase">
									<!-- 工程类别 -->
									<template v-if="last_need_modify?.info?.indexOf('type_of_work') !== -1">
										<div class="gf-prev-reject-block">
											<div class="flex"><div class="my_form2"><div class="form_title">工程类别</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_work}}</div></div></div>
											<div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['type_of_work'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div>
										</div>
									</template>
									<template v-else>
										<div class="flex"><div class="my_form2"><div class="form_title">工程类别</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_work}}</div></div></div>
									</template>
									<!-- 专业分类 -->
									<template v-if="last_need_modify?.info?.indexOf('type_of_major') !== -1">
										<div class="gf-prev-reject-block">
											<div class="flex"><div class="my_form2"><div class="form_title">专业分类</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_major}}</div></div></div>
											<div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['type_of_major'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div>
										</div>
									</template>
									<template v-else>
										<div class="flex"><div class="my_form2"><div class="form_title">专业分类</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_major}}</div></div></div>
									</template>
									<!-- 工法名称 -->
									<template v-if="last_need_modify?.info?.indexOf('name') !== -1">
										<div class="gf-prev-reject-block">
											<div class="flex"><div class="my_form2"><div class="form_title">工法名称</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.name}}</div></div></div>
											<div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['name'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div>
										</div>
									</template>
									<template v-else>
										<div class="flex"><div class="my_form2"><div class="form_title">工法名称</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.name}}</div></div></div>
									</template>
									<!-- 编写单位 -->
									<template v-if="last_need_modify?.info?.indexOf('unit') !== -1">
										<div class="gf-prev-reject-block">
											<div class="flex"><div class="my_form2"><div class="form_title">编写单位</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.unit}}</div></div></div>
											<div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['unit'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div>
										</div>
									</template>
									<template v-else>
										<div class="flex"><div class="my_form2"><div class="form_title">编写单位</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.unit}}</div></div></div>
									</template>
									<template v-if="last_need_modify?.info?.indexOf('gf_province') !== -1">
										<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">企业注册地</div><div class="form_content">{{getGongfaRegisterProvince(parameters.info, temformlist[0])}}</div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['gf_province'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
									</template>
									<template v-else><div class="flex"><div class="my_form2"><div class="form_title">企业注册地</div><div class="form_content">{{getGongfaRegisterProvince(parameters.info, temformlist[0])}}</div></div></div></template>
									<template v-if="last_need_modify?.info?.indexOf('author_names') !== -1">
										<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">工法完成人</div><div class="form_content"><span v-if="parameters.info && parameters.info.author_names"><block v-for="(author,index) in parameters.info.author_names" :key="index">{{ author.name }}<block v-if="index + 1 < parameters.info.author_names.length">、</block></block></span><span v-else>-</span></div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['author_names'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
									</template>
									<template v-else><div class="flex"><div class="my_form2"><div class="form_title">工法完成人</div><div class="form_content"><span v-if="parameters.info && parameters.info.author_names"><block v-for="(author,index) in parameters.info.author_names" :key="index">{{ author.name }}<block v-if="index + 1 < parameters.info.author_names.length">、</block></block></span><span v-else>-</span></div></div></div></template>
									<!-- 申报联系人/联系电话 -->
									<template v-if="last_need_modify?.info?.indexOf('contact') !== -1">
										<div class="gf-prev-reject-block">
											<div class="flex"><div class="my_form2"><div class="form_title">申报联系人/联系电话</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.username+'/'+parameters.info.phone}}</div></div></div>
											<div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['contact'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div>
										</div>
									</template>
									<template v-else>
										<div class="flex"><div class="my_form2"><div class="form_title">申报联系人/联系电话</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.username+'/'+parameters.info.phone}}</div></div></div>
									</template>
								</div>
							</div>
						</div>
						<!-- 退回修改：工法信息选择（div 表单形式，每行前 checkbox，选中后下方出现输入框） -->
						<div v-if="inRejectMode" class="form_right" style="border:1px solid #DDD;width:auto;margin-bottom:16px;">
							<div class="form_1" style="padding:0;margin:0;">
								<div class="form_box_content binfobase">
									<template v-for="field in rinfos">
										<div :key="field.id" class="flex reject-info-row">
											<div class="my_form2" style="display:flex;align-items:center;">
												<el-checkbox
													:key="'cb_' + field.id"
													:value="!!selectedInfoIds[field.id]"
													@change="(val) => onInfoFieldCheck(val, field)"
													style="flex-shrink:0;margin-right:8px;">
												</el-checkbox>
												<div class="form_title" style="flex-shrink:0;">{{field.name}}</div>
												<div class="form_content">{{field.value}}</div>
											</div>
										</div>
										<div :key="field.id + '_input'" v-if="selectedInfoIds[field.id]" style="border: 1px solid #ddd;padding:4px 12px 8px;">
											<el-input
												v-model="inlineInfoOpinions[field.id]"
												placeholder="请输入修改意见"
												type="textarea"
												:rows="2"
												size="small"/>
										</div>
									</template>
								</div>
							</div>
						</div>
						<!-- 文件列表：退回模式用 div 布局（行内出现意见框），普通模式用 table -->
						<template v-if="inRejectMode">
							<!-- 表头 -->
							<div style="display:flex;align-items:center;background:#F5F6F7;padding:8px 12px;font-size:13px;color:#808895;border-bottom:1px solid #EBEEF5;">
								<span style="width:70px;flex-shrink:0;text-align:center;">序号</span>
								<span style="flex:1;text-align:left;">文件</span>
								<span style="width:90px;text-align:center;">操作</span>
							</div>
							<template v-for="(row, idx) in temUnitlist">
								<!-- 文件行 -->
								<div :key="row.id" style="display:flex;align-items:center;padding:8px 12px;border-bottom:1px solid #EBEEF5;"
									:style="row.is_error ? 'background:#fff6f6;' : ''">
									<span style="width:70px;flex-shrink:0;display:flex;align-items:center;">
										<el-checkbox
											:value="rselectedfiles.some(f => f.id === row.id)"
											@change="(val) => handleFileCheckChange(val, row)"
											style="margin-right:4px;">
										</el-checkbox>
										<span>{{ idx + 1 }}</span>
									</span>
									<span style="flex:1;color:#262626;text-align:left;">{{ row.name }}</span>
									<span style="width:90px;text-align:center;">
										<template v-if="getFileUrls(row).length">
											<a v-for="(file, fileIndex) in getFileUrls(row)" :key="file.url" class="a01" :href="file.url" target="_blank" style="display:block;">{{ formatFileLinkLabel(file, fileIndex) }}</a>
										</template>
										<span v-else style="color:#C0C4CC;">未上传</span>
									</span>
								</div>
								<!-- 勾选后在该文件正下方显示意见输入框 -->
								<div :key="row.id + '_opinion'" v-if="rselectedfiles.some(f => f.id === row.id)"
									style="border:1px solid #ddd;border-top:none;padding:6px 12px 8px;background:#fafafa;">
									<el-input
										v-model="inlineFileOpinions[row.id]"
										placeholder="请输入修改意见"
										type="textarea"
										:rows="2"
										size="small"/>
								</div>
							</template>
						</template>
						<template v-else>
							<!-- 表头 -->
							<div style="display:flex;align-items:center;background:#F5F6F7;padding:8px 12px;font-size:13px;color:#808895;border-bottom:1px solid #EBEEF5;">
								<span style="width:70px;flex-shrink:0;text-align:center;">序号</span>
								<span style="flex:1;text-align:left;">文件</span>
								<span style="width:90px;text-align:center;">操作</span>
							</div>
							<template v-for="(row, idx) in temUnitlist">
								<!-- 被退回的文件：整块红色背景 + disabled 意见框 -->
								<template v-if="row.is_error">
									<div :key="row.id" class="gf-prev-reject-block" style="display:flex;align-items:center;padding:8px 12px;">
										<span style="width:70px;flex-shrink:0;text-align:center;">{{ idx + 1 }}</span>
										<span style="flex:1;text-align:left;">{{ row.name }}</span>
										<span style="width:90px;text-align:center;">
											<template v-if="getFileUrls(row).length">
												<a v-for="(file, fileIndex) in getFileUrls(row)" :key="file.url" class="a01 gf-file-link-white" :href="file.url" target="_blank" style="display:block;">{{ formatFileLinkLabel(file, fileIndex) }}</a>
											</template>
											<span v-else style="color:#ffb3b8;">未上传</span>
										</span>
									</div>
									<div :key="row.id + '_prev_opinion'" class="gf-prev-reject-block" style="padding:0 12px 8px;">
										<el-input :value="row.opinion || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/>
									</div>
								</template>
								<!-- 正常文件行 -->
								<div v-else :key="row.id" style="display:flex;align-items:center;padding:8px 12px;border-bottom:1px solid #EBEEF5;">
									<span style="width:70px;flex-shrink:0;text-align:center;">{{ idx + 1 }}</span>
									<span style="flex:1;color:#262626;text-align:left;">{{ row.name }}</span>
									<span style="width:90px;text-align:center;">
										<template v-if="getFileUrls(row).length">
											<a v-for="(file, fileIndex) in getFileUrls(row)" :key="file.url" class="a01" :href="file.url" target="_blank" style="display:block;">{{ formatFileLinkLabel(file, fileIndex) }}</a>
										</template>
										<span v-else style="color:#C0C4CC;">未上传</span>
									</span>
								</div>
							</template>
						</template>
				</div><!-- end 材料审核 -->

				<!-- Tab 2：审核意见 -->
				<div v-show="activeName === 'three'" style="padding-top:10px;">
					<review-opinion-sheet ref="mainReviewOpinionSheet" @opinionsave="opinionsave" :initial="opiniondata" :award_log_id="id" :is_view="is_opinion_view"/>
					<div v-if="cstatus == 0 && enterMode === 'review' && temformlist.length" style="text-align:center;margin-top:20px;padding-bottom:20px;">
						<el-button type="primary" size="medium" @click="doSubmitMainReview">提交审核</el-button>
					</div>
				</div>

				<!-- Tab 3：审核日志 -->
				<div v-show="activeName === 'four'" style="padding-top:10px;">
					<el-table :data="visibleCheckedlogs"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" :cell-style="{'text-align':'center'}">
						<el-table-column :show-overflow-tooltip="true" prop="no" label="序号" min-width="60"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="dept" label="所属部门" min-width="110"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="checker" label="处理人" min-width="90"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="action" label="动作" min-width="80"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="step" label="当前节点" min-width="130"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="checkedAt" label="处理时间" min-width="140"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" label="处理意见" min-width="180">
							<template slot-scope="scope"><div>{{scope.row.checkedStatus}}</div></template>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="nstep" label="下一个节点" min-width="130"></el-table-column>
					</el-table>
				</div>

			</template>

			<!-- ====== 组长 视图 ====== -->
			<template v-if="activerole === 'leader'">

				<!-- 顶部单行 table -->
				<el-table v-if="temformlist.length" :data="temformlist"
					:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
					style="width:100%;margin-bottom:0;" :cell-style="{'text-align':'center'}">
					<el-table-column prop="no" label="序号" min-width="60"></el-table-column>
					<el-table-column label="单位" min-width="120">
						<template slot-scope="scope">{{scope.row.content && scope.row.content.info ? scope.row.content.info.unit : scope.row.user && scope.row.user.name}}</template>
					</el-table-column>
					<el-table-column prop="content.info.type_of_work" label="工法类型" min-width="100"></el-table-column>
					<el-table-column prop="content.info.name" label="工法名称" min-width="100"></el-table-column>
					<el-table-column label="工法完成人" min-width="100">
						<template slot-scope="scope">
							<block v-for="(author,index) in scope.row.content.info.author_names">{{author.name}}<block v-if="index+1 < scope.row.content.info.author_names.length">、</block></block>
						</template>
					</el-table-column>
					<el-table-column prop="created_at" label="提交时间" min-width="130"></el-table-column>
					<el-table-column label="状态" min-width="90">
						<template slot-scope="scope">
							<span :style="{color: getLeaderPrimaryStatusColor(scope.row), fontWeight:500}">{{getLeaderPrimaryStatusText(scope.row)}}</span>
						</template>
					</el-table-column>
				</el-table>

				<!-- 三个 Tab -->
				<div style="align-items:center;justify-content:space-between;margin-top:10px;">
					<el-tabs v-model="activeName" tab-position="top" style="flex:1;margin-bottom:0;">
						<el-tab-pane label="材料审核" name="first"></el-tab-pane>
						<el-tab-pane label="审核意见" name="three"></el-tab-pane>
						<el-tab-pane label="审核日志" name="four"></el-tab-pane>
					</el-tabs>
				</div>

				<!-- Tab 1：材料审核（与主审/副审完全相同的布局和逻辑，数据来源为组长自身的退回记录） -->
				<div v-show="activeName === 'first'" style="padding-top:10px;">
					<!-- 上次退回原因 -->
					<div v-if="last_rejection_reason" class="last_rejection_reason" style="margin-bottom:12px;">
						<div>退回时间：{{last_updated_at}}</div>
						<div>退回理由：{{last_rejection_reason}}</div>
					</div>
					<div class="gf-return-hint">
						若当前材料内容有误、需修改后重新审核，可退回至企业处理，仅限退回一次。<br />
						操作步骤：点击【退回修改】→ 选中需退回条目 → 填写退回原因 → 提交完成退回
					</div>
					<!-- 退回修改 / 确认退回 操作按钮 -->
					<div v-if="cstatus == 0 && temformlist.length && canExpertReview(temformlist[0])" style="text-align:right;margin-bottom:14px;">
						<template v-if="inRejectMode">
							<el-button size="mini" @click="cancelRejectMode">取消</el-button>
							<el-button type="primary" class="tuibtn" size="mini" @click="confirmInlineReject">确认退回</el-button>
						</template>
						<template v-else-if="canUseReject(temformlist[0])">
							<el-button size="mini" class="tuibtn" @click="enterRejectMode">退回修改</el-button>
						</template>
					</div>
					<!-- 普通模式：基本信息（被退回项标 #fff2f3） -->
					<div v-if="!inRejectMode" class="form_right" style="border:1px solid #DDD;width:auto;margin-bottom:16px;">
						<div class="form_1" style="padding:0;margin:0;">
							<div class="form_box_content binfobase">
								<template v-if="last_need_modify?.info?.indexOf('type_of_work') !== -1">
									<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">工程类别</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_work}}</div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['type_of_work'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
								</template>
								<template v-else><div class="flex"><div class="my_form2"><div class="form_title">工程类别</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_work}}</div></div></div></template>
								<template v-if="last_need_modify?.info?.indexOf('type_of_major') !== -1">
									<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">专业分类</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_major}}</div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['type_of_major'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
								</template>
								<template v-else><div class="flex"><div class="my_form2"><div class="form_title">专业分类</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_major}}</div></div></div></template>
								<template v-if="last_need_modify?.info?.indexOf('name') !== -1">
									<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">工法名称</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.name}}</div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['name'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
								</template>
								<template v-else><div class="flex"><div class="my_form2"><div class="form_title">工法名称</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.name}}</div></div></div></template>
								<template v-if="last_need_modify?.info?.indexOf('unit') !== -1">
									<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">编写单位</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.unit}}</div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['unit'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
								</template>
								<template v-else><div class="flex"><div class="my_form2"><div class="form_title">编写单位</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.unit}}</div></div></div></template>
								<template v-if="last_need_modify?.info?.indexOf('gf_province') !== -1">
									<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">企业注册地</div><div class="form_content">{{getGongfaRegisterProvince(parameters.info, temformlist[0])}}</div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['gf_province'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
								</template>
								<template v-else><div class="flex"><div class="my_form2"><div class="form_title">企业注册地</div><div class="form_content">{{getGongfaRegisterProvince(parameters.info, temformlist[0])}}</div></div></div></template>
								<template v-if="last_need_modify?.info?.indexOf('author_names') !== -1">
									<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">工法完成人</div><div class="form_content"><span v-if="parameters.info && parameters.info.author_names"><block v-for="(author,index) in parameters.info.author_names" :key="index">{{ author.name }}<block v-if="index + 1 < parameters.info.author_names.length">、</block></block></span><span v-else>-</span></div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['author_names'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
								</template>
								<template v-else><div class="flex"><div class="my_form2"><div class="form_title">工法完成人</div><div class="form_content"><span v-if="parameters.info && parameters.info.author_names"><block v-for="(author,index) in parameters.info.author_names" :key="index">{{ author.name }}<block v-if="index + 1 < parameters.info.author_names.length">、</block></block></span><span v-else>-</span></div></div></div></template>
								<template v-if="last_need_modify?.info?.indexOf('contact') !== -1">
									<div class="gf-prev-reject-block"><div class="flex"><div class="my_form2"><div class="form_title">申报联系人/联系电话</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.username+'/'+parameters.info.phone}}</div></div></div><div style="padding:4px 12px 8px;"><el-input :value="lastRejectOpinions['contact'] || ''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div></div>
								</template>
								<template v-else><div class="flex"><div class="my_form2"><div class="form_title">申报联系人/联系电话</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.username+'/'+parameters.info.phone}}</div></div></div></template>
							</div>
						</div>
					</div>
					<!-- 退回模式：基本信息（checkbox 可勾选 + 意见输入框） -->
					<div v-if="inRejectMode" class="form_right" style="border:1px solid #DDD;width:auto;margin-bottom:16px;">
						<div class="form_1" style="padding:0;margin:0;">
							<div class="form_box_content binfobase">
								<template v-for="field in rinfos">
									<div :key="field.id" class="flex reject-info-row">
										<div class="my_form2" style="display:flex;align-items:center;">
											<el-checkbox :key="'cb_'+field.id" :value="!!selectedInfoIds[field.id]" @change="(val) => onInfoFieldCheck(val, field)" style="flex-shrink:0;margin-right:8px;"></el-checkbox>
											<div class="form_title" style="flex-shrink:0;">{{field.name}}</div>
											<div class="form_content">{{field.value}}</div>
										</div>
									</div>
									<div :key="field.id+'_input'" v-if="selectedInfoIds[field.id]" style="border:1px solid #ddd;padding:4px 12px 8px;">
										<el-input v-model="inlineInfoOpinions[field.id]" placeholder="请输入修改意见" type="textarea" :rows="2" size="small"/>
									</div>
								</template>
							</div>
						</div>
					</div>
					<!-- 文件列表 -->
					<template v-if="inRejectMode">
						<div style="display:flex;align-items:center;background:#F5F6F7;padding:8px 12px;font-size:13px;color:#808895;border-bottom:1px solid #EBEEF5;">
							<span style="width:70px;flex-shrink:0;text-align:center;">序号</span>
							<span style="flex:1;text-align:left;">文件</span>
							<span style="width:90px;text-align:center;">操作</span>
						</div>
						<template v-for="(row, idx) in temUnitlist">
							<div :key="row.id" style="display:flex;align-items:center;padding:8px 12px;border-bottom:1px solid #EBEEF5;" :style="row.is_error ? 'background:#fff6f6;' : ''">
								<span style="width:70px;flex-shrink:0;display:flex;align-items:center;">
									<el-checkbox :value="rselectedfiles.some(f => f.id === row.id)" @change="(val) => handleFileCheckChange(val, row)" style="margin-right:4px;"></el-checkbox>
									<span>{{ idx + 1 }}</span>
								</span>
								<span style="flex:1;color:#262626;text-align:left;">{{ row.name }}</span>
								<span style="width:90px;text-align:center;"><template v-if="getFileUrls(row).length"><a v-for="(file, fileIndex) in getFileUrls(row)" :key="file.url" class="a01" :href="file.url" target="_blank" style="display:block;">{{ formatFileLinkLabel(file, fileIndex) }}</a></template><span v-else style="color:#C0C4CC;">未上传</span></span>
							</div>
							<div :key="row.id+'_opinion'" v-if="rselectedfiles.some(f => f.id === row.id)" style="border:1px solid #ddd;border-top:none;padding:6px 12px 8px;background:#fafafa;">
								<el-input v-model="inlineFileOpinions[row.id]" placeholder="请输入修改意见" type="textarea" :rows="2" size="small"/>
							</div>
						</template>
					</template>
					<template v-else>
						<div style="display:flex;align-items:center;background:#F5F6F7;padding:8px 12px;font-size:13px;color:#808895;border-bottom:1px solid #EBEEF5;">
							<span style="width:70px;flex-shrink:0;text-align:center;">序号</span>
							<span style="flex:1;text-align:left;">文件</span>
							<span style="width:90px;text-align:center;">操作</span>
						</div>
						<template v-for="(row, idx) in temUnitlist">
							<template v-if="row.is_error">
								<div :key="row.id" class="gf-prev-reject-block" style="display:flex;align-items:center;padding:8px 12px;">
									<span style="width:70px;flex-shrink:0;text-align:center;">{{ idx + 1 }}</span>
									<span style="flex:1;text-align:left;">{{ row.name }}</span>
									<span style="width:90px;text-align:center;"><template v-if="getFileUrls(row).length"><a v-for="(file, fileIndex) in getFileUrls(row)" :key="file.url" class="a01 gf-file-link-white" :href="file.url" target="_blank" style="display:block;">{{ formatFileLinkLabel(file, fileIndex) }}</a></template><span v-else style="color:#ffb3b8;">未上传</span></span>
								</div>
								<div :key="row.id+'_op'" class="gf-prev-reject-block" style="padding:0 12px 8px;"><el-input :value="row.opinion||''" type="textarea" :rows="2" size="small" disabled class="gf-reject-readonly-input"/></div>
							</template>
							<div v-else :key="row.id" style="display:flex;align-items:center;padding:8px 12px;border-bottom:1px solid #EBEEF5;">
								<span style="width:70px;flex-shrink:0;text-align:center;">{{ idx + 1 }}</span>
								<span style="flex:1;color:#262626;text-align:left;">{{ row.name }}</span>
								<span style="width:90px;text-align:center;"><template v-if="getFileUrls(row).length"><a v-for="(file, fileIndex) in getFileUrls(row)" :key="file.url" class="a01" :href="file.url" target="_blank" style="display:block;">{{ formatFileLinkLabel(file, fileIndex) }}</a></template><span v-else style="color:#C0C4CC;">未上传</span></span>
							</div>
						</template>
					</template>
				</div>

				<!-- Tab 2：审核意见 -->
				<div v-show="activeName === 'three'" style="padding-top:10px;">
					<el-tabs v-model="lroption" tab-position="top">
						<!-- 组长意见 tab -->
						<el-tab-pane label="组长" name="leader_tab">
							<!-- 审核结果 -->
							<div style="display:flex;align-items:center;padding:16px 0 12px;">
								<span style="width:90px;flex-shrink:0;font-size:14px;color:#606266;">组长审核结果</span>
								<el-radio-group v-model="leaderRecommend">
									<el-radio :label="true" style="margin-right:24px;">推荐</el-radio>
									<el-radio :label="false">不推荐</el-radio>
								</el-radio-group>
							</div>
							<!-- 审核意见 -->
							<div style="border:1px solid #EBEEF5;border-radius:4px;padding:12px;">
								<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
									<span style="font-size:14px;color:#606266;">组长审核意见：</span>
									<el-button size="mini" plain @click="leaderOpinion=''">一键清空</el-button>
								</div>
								<el-input v-model="leaderOpinion" type="textarea" :rows="6" placeholder="请输入审核意见（不推荐时必填）" :disabled="cstatus==1"/>
							</div>
							<!-- 提交按钮 -->
							<div v-if="cstatus==0" style="text-align:center;margin-top:20px;padding-bottom:20px;">
								<el-button type="primary" size="medium" @click="doSubmitLeaderReview">提交审核</el-button>
							</div>
						</el-tab-pane>
						<!-- 主审意见 tab -->
						<el-tab-pane label="主审" name="mc">
							<review-opinion-sheet :initial="curObj.mainexpert && curObj.mainexpert.checked_opinions" :award_log_id="id" :is_view="1"/>
						</el-tab-pane>
						<!-- 副审意见 tab -->
						<el-tab-pane label="副审" name="rc">
							<review-opinion-sheet :initial="curObj.reexpert && curObj.reexpert.checked_opinions" :award_log_id="id" :is_view="1"/>
						</el-tab-pane>
					</el-tabs>
				</div>

				<!-- Tab 3：审核日志 -->
				<div v-show="activeName === 'four'" style="padding-top:10px;">
					<el-table :data="visibleCheckedlogs"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" :cell-style="{'text-align':'center'}">
						<el-table-column :show-overflow-tooltip="true" prop="no" label="序号" min-width="60"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="dept" label="所属部门" min-width="110"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="checker" label="处理人" min-width="90"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="action" label="动作" min-width="80"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="step" label="当前节点" min-width="130"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="checkedAt" label="处理时间" min-width="140"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" label="处理意见" min-width="180">
							<template slot-scope="scope"><div>{{scope.row.checkedStatus}}</div></template>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="nstep" label="下一个节点" min-width="130"></el-table-column>
					</el-table>
				</div>

			</el-tabs>
			</template><!-- end 组长视图 -->


		</div>

        <!-- start 不通过 start-->
        <el-dialog title="驳回" :visible.sync="dialogVisible" width="774px" >
                <div class="checkeddiv">
                    <div class="ctitle">驳回选择</div>
                    <div class="cval">
                        <el-radio-group v-model="reject" >
                            <el-radio v-if="activerole != 'leader'" :label="7">打回企业修正</el-radio>
                            <el-radio :label="6"> {{ activerole == 'leader' ? '不通过' : '不通过,提交终审' }}</el-radio>
                          </el-radio-group>
                    </div>
                    
                    <div class="ctitle">驳回理由</div>
                    <div class="cval">
                        <div  v-if="activerole == 'leader'" style="border-bottom:1px solid #DDDDDD;width:100%;padding-bottom:10px;">
                            <el-checkbox-group v-model="reject_agreement">
                                <el-checkbox label="main">同意主审意见</el-checkbox>
                                <el-checkbox label="second">同意副审意见</el-checkbox>
                              </el-checkbox-group>
                            <el-button size="mini" plain style="margin-top:8px;" @click="reason = ''">一键清空</el-button>
                        </div>
                        <textarea class="reason" name="" id="" cols="30" rows="10" maxlength="500" v-model="reason"
                          placeholder="点击输入无法通过审核的原因..."></textarea>
                    </div>
                </div>
                <div class="warntip"> 请确认需企业修改项目，如无需企业修改条例请取消勾选，避免重新审查增加各专家审核工作量 </div>
                <el-tabs style="" v-model="rejecttab" tab-position="top" v-show="reject == 7">
				    <el-tab-pane label="文件" name="rfile">
				        <el-table :data="rfiles" ref="rfileTable"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" row-key='id' :cell-style="{'text-align':'center'}" @selection-change="handleRejectFileChange">
                            <el-table-column
                              type="selection"
                              width="55">
                            </el-table-column>
        					<el-table-column prop="no" label="序号" min-width="80">
                            </el-table-column>
                            <el-table-column  prop="name" label="文件" show-overflow-tooltip min-width="160">
                            </el-table-column>
                            <el-table-column label="修改意见" min-width="220">
                                <template slot-scope="scope">
                                    <el-input
                                      v-if="isRejectItemSelected('file', scope.row)"
                                      type="textarea"
                                      :rows="2"
                                      maxlength="300"
                                      show-word-limit
                                      placeholder="请填写该项修改意见"
                                      v-model="rejectItemOpinions[getRejectOpinionKey('file', scope.row)]"
                                    />
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
        				</el-table>
				    </el-tab-pane>
				    <el-tab-pane label="工法信息" name="rinfo">
				        <el-table :data="rinfos" ref="rinfoTable" 
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;"  row-key='id'  :cell-style="{'text-align':'center'}" @selection-change="handleRejectInfoChange">
                            <el-table-column
                              type="selection"
                              width="55">
                            </el-table-column>
        					<el-table-column prop="name" label="填写项" min-width="80">
                            </el-table-column>
                            <el-table-column  prop="value" label="填写内容" show-overflow-tooltip min-width="160">
                            </el-table-column>
                            <el-table-column label="修改意见" min-width="220">
                                <template slot-scope="scope">
                                    <el-input
                                      v-if="isRejectItemSelected('info', scope.row)"
                                      type="textarea"
                                      :rows="2"
                                      maxlength="300"
                                      show-word-limit
                                      placeholder="请填写该项修改意见"
                                      v-model="rejectItemOpinions[getRejectOpinionKey('info', scope.row)]"
                                    />
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
        				</el-table>
				    </el-tab-pane>
				    
				    
				</el-tabs>
                <span slot="footer" class="dialog-footer" style="margin:0 auto;text-align:center;">
                        <el-button type="default"  @click="dialogVisible = false" style="margin-right:20px;">取消</el-button>
    					<el-button type="primary"  @click="rejectsumbit">确认提交</el-button>
    				</span>
            </el-dialog>
            
            <el-dialog title="审核通过" :visible.sync="agreedialogVisible" width="774px" >
                <div class="checkeddiv">
                    <div class="ctitle">审核结果</div>
                    <div class="cval">
                        审核通过
                    </div>
                    
                    <div class="ctitle">审核意见</div>
                    <div class="cval">
                        <div style="border-bottom:1px solid #DDDDDD;width:100%;padding-bottom:10px;">
                            <el-checkbox-group v-model="reject_agreement">
                                <el-checkbox label="main">同意主审意见</el-checkbox>
                                <el-checkbox label="second">同意副审意见</el-checkbox>>
                              </el-checkbox-group>
                        </div>
                        <textarea class="reason" name="" id="" cols="30" rows="10" maxlength="500" v-model="reason"
                          placeholder="点击输入审核意见的原因..."></textarea>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer" style="margin:0 auto;text-align:center;">
                        <el-button type="default"  @click="agreedialogVisible = false" style="margin-right:20px;">取消</el-button>
    					<el-button type="primary"  @click="agreesumbit">确认提交</el-button>
    				</span>
            </el-dialog>
            <el-dialog title="退回初审" :visible.sync="returnInitialVisible" width="520px">
                <el-form label-width="90px" label-position="left" size="small">
                    <el-form-item label="退回专家(可多选)" required>
                        <el-checkbox-group v-model="returnInitialExperts">
                            <el-checkbox label="main">主审专家</el-checkbox>
                            <el-checkbox label="second">副审专家</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="margin:0 auto;text-align:center;">
                    <el-button type="default" @click="handleReturnInitialClose" style="margin-right:20px;">取消</el-button>
                    <el-button type="primary" @click="submitReturnInitial">确认退回</el-button>
                </span>
            </el-dialog>
            <el-dialog title="短信通知失败原因" :visible.sync="smsFailVisible" width="480px">
                <div v-if="smsFailInfo" style="font-size:14px;line-height:1.9;color:#303133;">
                    <p>因【{{ getSmsFailReason(smsFailInfo.fail_reason) }}】，短信通知失败。</p>
                    <p v-if="smsFailInfo.show_contact_tip" style="color:#E6A23C;margin-top:8px;">{{ smsFailureContactTip }}</p>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="smsFailVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
             
             
    <!--        <el-dialog title="请选择驳回项目并附上驳回理由" :visible.sync="dialogVisible" width="774px" >-->
    <!--            <div class="checkeddiv">-->
    <!--                <div class="ctitle">驳回选择</div>-->
    <!--                <div class="cval">-->
    <!--                    <el-radio-group v-model="reject" >-->
    <!--                        <el-radio :label="7">打回企业修正</el-radio>-->
    <!--                        <el-radio :label="6"> {{ activerole == 'leader' ? '不通过' : '不通过,提交终审' }}</el-radio>-->
    <!--                      </el-radio-group>-->
    <!--                </div>-->
                    
    <!--                <div class="ctitle">驳回理由</div>-->
    <!--                <div class="cval">-->
    <!--                    <div  v-if="activerole == 'leader'" style="border-bottom:1px solid #DDDDDD;width:100%;padding-bottom:10px;">-->
    <!--                        <el-checkbox-group v-model="reject_agreement">-->
    <!--                            <el-checkbox label="main">同意主审意见</el-checkbox>-->
    <!--                            <el-checkbox label="second">同意副审意见</el-checkbox>>-->
    <!--                          </el-checkbox-group>-->
    <!--                    </div>-->
    <!--                    <textarea class="reason" name="" id="" cols="30" rows="10" maxlength="500" v-model="reason"-->
    <!--                      placeholder="点击输入无法通过审核的原因..."></textarea>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--            <el-tabs style="" v-model="rejecttab" tab-position="top" v-if="reject == 7">-->
				<!--    <el-tab-pane label="工法信息" name="rinfo">-->
				<!--        <el-table :data="rinfos"-->
				<!--		:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"-->
				<!--		style="width: 100%;"  row-key='id'  :cell-style="{'text-align':'center'}" @selection-change="handleRejectInfoChange">-->
    <!--                        <el-table-column-->
    <!--                          type="selection"-->
    <!--                          width="55">-->
    <!--                        </el-table-column>-->
    <!--    					<el-table-column prop="name" label="填写项" min-width="80">-->
    <!--                        </el-table-column>-->
    <!--                        <el-table-column  prop="value" label="填写内容" show-overflow-tooltip min-width="160">-->
    <!--                        </el-table-column>-->
    <!--    				</el-table>-->
				<!--    </el-tab-pane>-->
				<!--    <el-tab-pane label="文件" name="rfile">-->
				<!--        <el-table :data="rfiles"-->
				<!--		:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"-->
				<!--		style="width: 100%;" row-key='id' :cell-style="{'text-align':'center'}" @selection-change="handleRejectFileChange">-->
    <!--                        <el-table-column-->
    <!--                          type="selection"-->
    <!--                          width="55">-->
    <!--                        </el-table-column>-->
    <!--    					<el-table-column prop="no" label="序号" min-width="80">-->
    <!--                        </el-table-column>-->
    <!--                        <el-table-column  prop="name" label="文件" show-overflow-tooltip min-width="160">-->
    <!--                        </el-table-column>-->
    <!--    				</el-table>-->
				<!--    </el-tab-pane>-->
				    
				<!--</el-tabs>-->
    <!--            <span slot="footer" class="dialog-footer" style="margin:0 auto;text-align:center;">-->
    <!--                    <el-button type="default"  @click="dialogVisible = false" style="margin-right:20px;">取消</el-button>-->
    <!--					<el-button type="primary"  @click="rejectsumbit">确认提交</el-button>-->
    <!--				</span>-->
    <!--        </el-dialog>-->
        <!-- start 不通过 end-->
        
         <!-- start 驳回修订 start-->
        <!-- start 驳回修订 end-->
        
        
    <!--    <el-dialog title="填写不通过原因" :visible.sync="dialogVisible" width="774px" :before-close="handleClose">-->
    <!--        <div class="yellow-box">-->
    <!--            <span>{{ user.legal_representative_id }}</span>-->
    <!--            <span>{{ user.name }}</span>-->
    <!--            <span>申请提交于{{ created_at }}</span>-->
    <!--        </div>-->
    <!--        <textarea class="reason" name="" id="" cols="30" rows="10" maxlength="500" v-model="reason"-->
    <!--                  placeholder="点击输入无法通过审核的原因..."></textarea>-->
    <!--        <span slot="footer" class="dialog-footer">-->
				<!--	<el-button type="primary" icon="el-icon-check" @click="sumbit">确认提交</el-button>-->
				<!--</span>-->
    <!--    </el-dialog>-->
	</div>
</template>

<script>
	import AllHeader from "@/components/Modal/AllHeader";
	import Pagetion from "@/components/Modal/Pagetion";
	import ReviewOpinionSheet from '@/components/expert/ReviewOpinionSheet.vue';

	import {
       AwardBatches,
       expertawardgflogs,
       expertgfverify,
       echeckedlogs,
       expertgfbverify,
       expertAwardSummaryExport,
       expertAwardScoreBatchExport
	} from "../../utils/api.js";
	const { isGongfaTimeoutTerminated } = require('../../utils/gongfaExpertReviewState');
	const {
        getRejectOpinionKey,
        validateRejectItems,
    } = require('../../utils/gongfaExpertReject');
	const {
        buildReturnInitialPayload,
        buildReviewDecisionFromOpinion,
        normalizeRecommendDecision,
        canLeaderReview: canGongfaLeaderReview,
        isInitialReviewComplete,
    } = require('../../utils/gongfaLeaderReview');
	export default {
		components: {
			AllHeader,
			Pagetion,
			ReviewOpinionSheet
		},
		data() {
			return {
                loading:true,
                download:false,
				dialogVisible: false,
                dialogUnitVisible: false,
                dialogTableVisible:false,
                dialogZJVisible:false,
				step: 0,
                timeRange: '',
                exportType:1,
				ischage: false,
				lable: "材料审核",
				pageSize: 10,
				total: 0,
				awardList: [],
				sublabel: "返回列表",
				subtitle: "", //副标题
				formlist: [],
				temformlist: [],
				temUnitlist:[],//参加单位信息
				temFilelist:[],//申报登记表需补充内容
                temRecommandlist:[],//推荐表
                temSupplementlist:[],
                zjlist:[],
                zjId:[],
                unit:{},//参加单位信息
				user: {},
				id: '',
				reason: "",
				year: null,
				activeName: "first",
				parameters:{"Contractorinfo":{},"SupplementaryContent":{},"info":{}},
                keyword:'',
                searchYear:'',
                searchstatus:'1',
                award_id:0,
				curObj: {}, // 当前点击的行
				isShowAssignGroup: false,
				reAssign: false,
                batches:[],
                checkedlogs:[],
                created_at:'',
                award_batch_id:0,
                activestatus:0,
                astatus:'',
                wtype:'',
                dates:null,
                mainopiniondata:[],
                reopiniondata:[],
                projectSpan: [],
                dialogOpinionVisible:false,
                nrow : {},
                dialogRejectVisible:false, //显示驳回理由
                nlog:{},
                reject:0, //驳回类型
        		reason:'', //驳回原因
        		rejecttab:'rfile', //驳回标签
        		rinfos:[],
        		rfiles:[],
        		rselectedinfos:[],
        		rselectedfiles:[],
                rejectItemOpinions:{},
        		activerole:'main',
        		opiniondata:{ 'name_match':'','enterprise_approval':'','outside_province':'','name_content_match':'','hierarchy_order':'','table_figures':'','features':'','content_items':'','scope':'','environment':'','cases':'','process_keypoints':'','key_tech_level':'','suitable_in_province':'','recommend_provincial':'','rejection_reason':'','main_units_members':''},
        		cstatus:0,
        		lroption:'leader_tab',
                leaderRecommend: null,
                leaderOpinion: '',
        		reject_agreement:[],
        		nmr:'mrinfo',
        		selected_log_ids:[],
        		rejectbatch :0,
                inRejectMode: false,
                inlineFileOpinions: {},
                inlineInfoOpinions: {},
                selectedInfoIds: {},
                tableColumnFilters: {},
                tableWtypeFilter: '',
                enterMode: 'review',
                mainReviewVisible: false,
                mainReviewResult: '1',
                mainReviewReason: '',
				rejectRow:null,
        		bname:'',
        		is_opinion_view:0,
        		is_opinion_save:0,
        		last_rejection_reason:'',
        		last_need_modify:{},
                lastRejectOpinions:{},
        		rowClassName:'',
        		agreedialogVisible:false,
        		agreerow:{},
                returnInitialVisible:false,
                returnInitialReason:'',
                returnInitialExperts:[],
                returnInitialRow:null,
        		rowindex:0,
        		last_updated_at:'',
                smsFailVisible:false,
                smsFailInfo:null,
                tableStatusFilter:'',
                smsFailureContactTip:'如通知失败非企业停机、空号、暂停服务、关机、不在服务区的原因造成，请及时联系告知评审办公室。'
			};
		},
		mounted() {
		    
		   //let award_batch_id = this.$route.fullPath.indexOf('unchecked') != -1 ? parseInt(this.$route.fullPath.replace('/expertmember/Awardlogreview/unchecked/','')) :  parseInt(this.$route.fullPath.replace('/expertmember/Awardlogreview/checked/',''));

			this.cstatus = this.$route.fullPath.indexOf('unchecked') != -1 ? 0 : 1;//this.$route.query.cstatus != undefined ? this.$route.query.cstatus : 0;
			console.log('cstatus',this.cstatus);
			console.log('this.$route.fullPath',this.$route.fullPath);
			console.log('[gf-review] mounted state', {
			    activerole: this.activerole,
			    cstatus: this.cstatus,
			    query: this.$route && this.$route.query,
			});
			this.searchYear = this.award_batch_id = this.$route.query.award_batch_id;
			let is_leader  = this.$route.query.is_leader;
			if(is_leader == 1){
			    this.activerole = 'leader';
			}
			this.award_id = this.$route.query.award_id;
			this.bname = this.$route.query.bname;
			this.logAuditState('mounted');
			this.initList(1);
            this.getBatches();
			
		},
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 250) + 'px'; //自定义高度需求
            },
            visibleCheckedlogs() {
                return this.filterCheckedlogsByRole(this.checkedlogs)
            },
            showExpertAuditButtons() {
                return String(this.$route.query.is_leader) !== '1'
            },
            reviewStatusFilters() {
                if (this.cstatus === 1) {
                    return [
                        { text: '已推荐', value: 'leader_pass' },
                        { text: '不推荐', value: 'leader_reject' },
                    ]
                }
                return [
                    { text: '初审中', value: '2' },
                    { text: '待中审', value: '3' },
                    { text: '已退回', value: '7' },
                    { text: '超时终止', value: '9' },
                ]
            },
            leaderResultFilters() {
                return [
                    { text: '推荐', value: '1' },
                    { text: '不推荐', value: '0' },
                    { text: '退回', value: '3' },
                    { text: '待审核', value: 'pending' },
                ]
            },
            leaderWtypeFilters() {
                return [
                    { text: '房屋建筑工程', value: '房屋建筑工程' },
                    { text: '土木工程', value: '土木工程' },
                    { text: '工业安装工程', value: '工业安装工程' },
                ]
            },
        },
		methods: {
		    getFileUrls(row) {
		        if (Array.isArray(row && row.urls) && row.urls.length) return row.urls;
		        return row && row.url ? [{ url: row.url, name: row.name }] : [];
		    },
		    formatFileLinkLabel(file, index) {
		        const value = `${(file && file.name) || ''} ${(file && file.url) || ''}`.toLowerCase();
		        const type = /\.(mp4|avi|flv)(?:$|[?#])/.test(value) ? '视频' : '文件';
		        return `${type}${index + 1}`;
		    },
		    logAuditState(tag, extra) {
		        console.log('[gf-review]', tag, {
		            route: {
		                path: this.$route && this.$route.path,
		                fullPath: this.$route && this.$route.fullPath,
		                query: this.$route && this.$route.query,
		            },
		            state: {
		                cstatus: this.cstatus,
		                activerole: this.activerole,
		                activeName: this.activeName,
		                enterMode: this.enterMode,
		                inRejectMode: this.inRejectMode,
		                showExpertAuditButtons: this.showExpertAuditButtons,
		                temformlistLength: this.temformlist.length,
		            },
		            extra: extra || {},
		        })
		    },
		    getLogRole(row){
		        if(!row){
		            return ''
		        }
		        const role = row.role || row.expert_role || row.reviewer_role || row.checker_role
		        if(role){
		            return String(role)
		        }
		        const isLeader = Number(row.is_leader || row.expert_is_leader || row.checked_is_leader || 0)
		        if(isLeader === 1) return 'leader'
		        if(isLeader === 2) return 'main'
		        if(isLeader === 3) return 'second'
		        if(isLeader === 4) return 'admin'
		        return ''
		    },
		    canViewCheckedlog(row){
		        const role = this.getLogRole(row)
		        // 企业提交（无角色）和管理员操作 —— 所有专家角色都可见
		        if(!role || role === 'admin'){
		            return true
		        }
		        if(this.activerole === 'leader'){
		            return ['leader', 'main', 'second'].indexOf(role) !== -1
		        }
		        // 主审/副审：只看自己的审核记录
		        return role === this.activerole
		    },
		    normalizeCheckedlog(row){
		        const map = {
		            submit: '企业提交',
		            withdraw: '企业自主撤回修改',
		            admin_return: '管理员退回',
		            resubmit: '企业重新提交',
		            auto_submit: '超期自动提交',
		            expert_return: '专家退回',
		            timeout_terminated: '逾期终止',
		            initial_review: '初审',
		            leader_review: '组长中审',
		            return_initial: '组长退回初审',
		            final_review: '管理员终审',
		        }
		        const action = row.action_type || row.log_type || row.event_type
		        if(action && map[action]){
		            return Object.assign({}, row, {
		                step: row.step || map[action],
		                checkedStatus: row.checkedStatus || row.checked_status_text || map[action],
		                checkedRemark: row.checkedRemark || row.reject_reason || row.remark || row.reason || '',
		            })
		        }
		        return row
		    },
		    filterCheckedlogsByRole(logs){
		        if(!Array.isArray(logs)){
		            return []
		        }
		        return logs
		            .map(this.normalizeCheckedlog)
		            .filter(this.canViewCheckedlog)
		    },
		     

		    agreesumbit(){
		        
				let data = {
					status: 1,
					reject_reason:this.reason,
					checked_agreement:this.reject_agreement
				}
				
                this.$confirm("确认通过？")
                    .then((_) => {
                        if(this.rejectbatch == 1){
                             expertgfbverify(data, this.selected_log_ids.join(',')).then(res => {
                                this.$message({
                                    message: "审核成功",
                                    type: "success",
                                })
                                this.initList(1);
                                this.getvalue();
                                this.agreedialogVisible = false;
                            }).catch(error => {
                                this.$message({
                                    message: error,
                                    type: "warning",
                                })
                            })
                            this.reject_agreement = []
                            this.rejectbatch = 0;
                        } else {
                            console.log('agreerow',this.agreerow);
                            expertgfverify(data, this.agreerow.id).then(res => {
                                this.$message({
                                    message: "审核成功",
                                    type: "success",
                                })
                                this.initList(1);
                                this.getvalue();
                                this.agreerow = {};
                                this.agreedialogVisible = false;
                            }).catch(error => {
                                this.$message({
                                    message: error,
                                    type: "warning",
                                })
                            })
                        }
                    })
                    .catch((_) => {});
		    },
		    rowClassName({row}){
		        return row.is_error == 1 ? 'fileerr' : ''
		    },
		    opinionsave(payload){
		        if(this.activerole == 'main'){
		            this.formlist[this.rowindex].mainexpert.checked_opinions = payload;
		        } else {
		            this.formlist[this.rowindex].reexpert.checked_opinions = payload;
		        }
		        this.opiniondata = payload;
		        if(payload['isFinished'] == 1){
		            this.is_opinion_save = 1;
		        }
		    },
		    getCurrentReviewOpinionPayload() {
		        const sheet = this.$refs.mainReviewOpinionSheet
		        if (sheet && typeof sheet.getPayload === 'function') {
		            return sheet.getPayload()
		        }
		        return this.opiniondata || {}
		    },
			toOpinion(id,award_log_id){
			        this.$router.push(`/ginfo?id=${id}&aid=${award_log_id}`)
			    },
			openApplicationDetail(row) {
				if (!row || !row.id) return
				const award = row.award || {}
				this.$router.push({
					path: '/word_1',
					query: {
						id: row.id,
						awardid: row.award_id || this.award_id,
						awardbatchid: row.award_batch_id || this.award_batch_id,
						title: award.title || '贵州省工程建设工法评定',
						is_view: 1
					}
				})
			},
			isReviewCompleted(row) {
				return Number(row && row.status) === 4
			},
			toBatch(){
		        console.log('award_id',this.award_id)
		          if (Number(this.award_id) === 21) {
		              this.$router.push(`/gfprize/Awardbatch?award_id=${this.award_id}`)
		              return
		          }
		          this.$router.push(`/expertmember/Awardbatch?award_id=${this.award_id}`)

		    },
			getGongfaRegisterProvince(info, awardLog) {
				const formInfo = info || {}
				const provinceType = formInfo.gf_province != null
					? formInfo.gf_province
					: (awardLog && awardLog.gf_province)
				if (String(provinceType) === '1') return '贵州省'

				const province = formInfo.gf_province_detail || formInfo.register_province ||
					(awardLog && awardLog.register_province)
				return province || (String(provinceType) === '2' ? '其他省' : '-')
			},
            getCurrentExpertRecord(row) {
                if (!row) return null
                if (this.activerole === 'main') return row.mainexpert || null
                if (this.activerole === 'second') return row.reexpert || null
                if (this.activerole === 'leader') return row.leader || null
                return null
            },
            isTimeoutTerminated(row) {
                return isGongfaTimeoutTerminated(row)
            },
            isReturnedRow(row) {
                if (!row) return false
                const current = this.getCurrentExpertRecord(row)
                return row.is_returned === true ||
                    row.is_returned === 1 ||
                    row.expert_return_status === 'returned' ||
                    Number(row.status) === 7 ||
                    this.isExpertRecordReturned(current)
            },
            isExpertRecordReturned(record) {
                if (!record) return false
                return Number(record.status) === 3 ||
                    Number(record.checked_status) === 3 ||
                    record.is_returned === true ||
                    record.is_returned === 1
            },
            isOwnReturnedRow(row) {
                const current = this.getCurrentExpertRecord(row)
                return !!(current && (current.reject_used === true || current.reject_used === 1))
            },
            canUseReject(row) {
                const current = this.getCurrentExpertRecord(row)
                if (current && (current.reject_used === true || current.reject_used === 1)) return false
                return true
            },
            canViewExpertRow(row) {
                return !this.isReturnedRow(row) || this.isTimeoutTerminated(row)
            },
            canExpertReview(row) {
                if (this.activerole === 'leader') {
                    return this.canLeaderReview(row)
                }
                const status = Number(row && row.status)
                if (!(status === 1 || status === 2 || status === 3)) return false
                if (this.isReturnedRow(row)) return false
                if (this.isTimeoutTerminated(row)) return false
                // 通过 AwardLog 级别的字段判断是否已提交意见
                // primary_checked_status / secondary_checked_status: 0=未审, 1=推荐, 2=不推荐, 3=退回
                if (this.activerole === 'main') {
                    const pcs = Number(row.primary_checked_status || 0)
                    if (pcs === 1 || pcs === 2 || pcs === 3) return false
                } else if (this.activerole === 'second') {
                    const scs = Number(row.secondary_checked_status || 0)
                    if (scs === 1 || scs === 2 || scs === 3) return false
                }
                // AwardLogExpert.status: 0=不通过/退回, 1=推荐（兜底）
                const current = this.getCurrentExpertRecord(row)
                if (current && (Number(current.status) === 0 || Number(current.status) === 1)) return false
                return true
            },
            canLeaderReview(row) {
                return canGongfaLeaderReview(row)
            },
            getLeaderStatusFilterValue(row) {
                const status = Number((row && row.status) || 0)
                const leaderRecord = row && row.leader
                const leaderStatus = leaderRecord && leaderRecord.status != null
                    ? Number(leaderRecord.status)
                    : Number((row && row.leader_checked_status) != null ? row.leader_checked_status : -1)
                if (this.cstatus === 1) {
                    if (this.isExpertRecordReturned(leaderRecord)) return 'leader_return'
                    if (leaderStatus === 1) return 'leader_pass'
                    if (leaderStatus === 0) return 'leader_reject'
                    return 'leader_pending'
                }
                if (status === 9) return '9'
                if (status === 7) return '7'
                if (status === 3) return '3'
                if (status === 2) return '2'
                return String(status || '')
            },
            getExpertResultFilterValue(record) {
                if (this.isExpertRecordReturned(record)) return '3'
                const status = Number(record && record.status)
                if (status === 1) return '1'
                if (status === 0) return '0'
                return 'pending'
            },
            getWtypeFilterValue(row) {
                return row && row.content && row.content.info ? row.content.info.type_of_work : ''
            },
            filterLeaderStatus(value, row) {
                return this.getLeaderStatusFilterValue(row) === value
            },
            filterMainResult(value, row) {
                return this.getExpertResultFilterValue(row && row.mainexpert) === value
            },
            filterSecondResult(value, row) {
                return this.getExpertResultFilterValue(row && row.reexpert) === value
            },
            filterWtype(value, row) {
                return this.getWtypeFilterValue(row) === value
            },
            getExpertReviewStatusText(row) {
                if (this.isTimeoutTerminated(row)) return '逾期终止'
                if (this.isReturnedRow(row)) return this.isOwnReturnedRow(row) ? '已退回' : '他人已退回'
                // 优先用 AwardLog 级别的决策字段
                if (this.activerole === 'main') {
                    const pcs = Number(row.primary_checked_status || 0)
                    if (pcs === 1) return '已推荐'
                    if (pcs === 2) return '不推荐'
                    if (pcs === 3) return '已退回'
                } else if (this.activerole === 'second') {
                    const scs = Number(row.secondary_checked_status || 0)
                    if (scs === 1) return '已推荐'
                    if (scs === 2) return '不推荐'
                    if (scs === 3) return '已退回'
                }
                const current = this.getCurrentExpertRecord(row)
                if (current && Number(current.status) === 0) return '不推荐'
                if (current && Number(current.status) === 1) return '已推荐'
                return '待初审'
            },
            getLeaderPrimaryStatusText(row) {
                const s = Number((row && row.status) || 0)
                const leaderStatus = Number((row && row.leader && row.leader.status) || row.leader_checked_status || -1)
                if (this.cstatus === 1) {
                    if (leaderStatus === 1) return '已推荐'
                    if (leaderStatus === 0) return '不推荐'
                }
                if (s === 9) return '超时终止'
                if (s === 7) return '已退回'
                if (s === 3) return '待中审'
                if (s === 2) return '初审中'
                return '初审中'
            },
            getLeaderPrimaryStatusColor(row) {
                const s = Number((row && row.status) || 0)
                const leaderStatus = Number((row && row.leader && row.leader.status) || row.leader_checked_status || -1)
                if (this.cstatus === 1) {
                    if (leaderStatus === 1) return '#67C23A'
                    if (leaderStatus === 0) return '#E51725'
                }
                if (s === 9) return '#FF6B09'
                if (s === 7) return '#595959'
                return '#194ABE'
            },
            getLeaderPrimaryStatusType(row) {
                const s = Number((row && row.status) || 0)
                if (s === 9) return 'info'
                if (s === 7) return 'info'
                return 'primary'
            },
            getExpertReviewStatusType(row) {
                if (this.isTimeoutTerminated(row)) return 'info'
                if (this.isReturnedRow(row)) return 'warning'
                const current = this.getCurrentExpertRecord(row)
                if (current && Number(current.status) === 1) return 'success'
                if (current && Number(current.status) === 0) return 'danger'
                return 'primary'
            },
            getExpertReviewStatusColor(row) {
                if (this.isTimeoutTerminated(row)) return '#FF6B09'
                if (this.isReturnedRow(row)) return '#595959'
                if (this.activerole === 'main') {
                    const pcs = Number(row.primary_checked_status || 0)
                    if (pcs === 1) return '#67C23A'
                    if (pcs === 2) return '#E51725'
                    if (pcs === 3) return '#595959'
                } else if (this.activerole === 'second') {
                    const scs = Number(row.secondary_checked_status || 0)
                    if (scs === 1) return '#67C23A'
                    if (scs === 2) return '#E51725'
                    if (scs === 3) return '#595959'
                }
                const current = this.getCurrentExpertRecord(row)
                if (current && Number(current.status) === 0) return '#E51725'
                if (current && Number(current.status) === 1) return '#67C23A'
                return '#194ABE'
            },
            getExpertOwnStatusText(row) {
                const current = this.getCurrentExpertRecord(row)
                if (!current) return '待初审'
                const s = Number(current.status)
                if (s === 0) return '不通过'
                if (s === 1) return '通过'
                if (s === 3) return '已退回'
                if (s === 2) return '待初审'
                return '待初审'
            },
            getExpertOwnStatusColor(row) {
                const current = this.getCurrentExpertRecord(row)
                if (!current) return '#194ABE'
                const s = Number(current.status)
                if (s === 0) return '#E51725'
                if (s === 1) return '#67C23A'
                if (s === 3) return '#595959'
                return '#194ABE'
            },
            // 主审/副审/组长状态文案
            getExpertStatusText(status) {
                const s = Number(status)
                if (s === 0) return '不通过'
                if (s === 1) return '已通过'
                if (s === 2) return '待初审'
                if (s === 3) return '已退回'
                return '待初审'
            },
            // 主审/副审/组长状态标签类型
            getExpertStatusTagType(status) {
                const s = Number(status)
                if (s === 0) return 'danger'
                if (s === 1) return 'success'
                if (s === 2) return 'info'
                if (s === 3) return 'warning'
                return 'info'
            },
            openSmsFailDialog(info) {
                this.smsFailInfo = info || null
                this.smsFailVisible = !!info
            },
            getSmsFailReason(failReason) {
                if (!failReason) return '未知原因'
                const parts = String(failReason).split(':')
                return parts.length > 1 ? parts.slice(1).join(':').trim() : String(failReason)
            },
		    handleBatchChecked(type){
		        if(this.selected_log_ids.length == 0){
		            this.$message.error('请选择评审记录')
    				return false
		        }
                const selectedRows = this.formlist.filter(item => this.selected_log_ids.indexOf(item.id) !== -1)
                const invalidRows = selectedRows.filter(item => this.activerole === 'leader' ? !this.canLeaderReview(item) : !this.canExpertReview(item))
                if (invalidRows.length > 0) {
                    this.$message.error('已退回或逾期终止的数据不可继续审核')
                    return false
                }
                if (type === 'reject' && selectedRows.some(item => !this.canUseReject(item))) {
                    this.$message.error('存在已使用退回权限的数据，不能重复退回')
                    return false
                }
		        if(type =='reject'){
		            this.reject = 7;
    		        this.reason = '';
                    this.rejectItemOpinions = {};
    		        this.rejecttab = 'rfiles';
    		        //组装工本信息
    		        this.rinfos = [
    		            {'name':'工程类别','value':'--','id':'type_of_work'},
    		            {'name':'专业分类','value':'--','id':'type_of_major'},
    		            {'name':'工法名称','value':'--','id':'name'},
		            {'name':'企业注册地','value':'--','id':'gf_province'},
    		            {'name':'联系人及电话','value':'--','id':'contact'},
    		            {'name':'编写单位','value':'--','id':'unit'},
    		            {'name':'完成人','value':'--','id':'author_names'},
    		            {'name':'电话','value':'--','id':'tel'}
    		            ];
    		        //组装文件
    		        this.rfiles = [
    		            {'name':'《贵州省工程建设施工工法申报表》（附件1）','id':'filelist3','no':1},
    		            {'name':'贵州省工程建设工法申报承诺书','id':'filelist_commitment','no':2},
    		            {'name':'工法文本','id':'filelist4','no':3},
    		            {'name':'企业工法证明材料','id':'filelist5','no':4},
    		            {'name':'工法关键技术专家论证的有关资料','id':'filelist6','no':5},
    		            {'name':'工程应用证明','id':'filelist7','no':6},
    		            {'name':'经济效益证明（附件2）','id':'filelist8','no':7},
    		            {'name':'工法应用的有关照片（10张以上）','id':'filelist12','no':8},
    		            {'name':'由技术情报部门提供的科技查新报告','id':'filelist9','no':9},
    		            {'name':'涉及他方专利的无争议声明书','id':'filelist10','no':10},
    		            {'name':'关键技术标准、专利证书、科技成果获奖证明等其他有关材料','id':'filelist11','no':11},
    		            {'name':'贵州省工程建设工法申报汇总表（附件3）PDF盖章版','id':'filelist1','no':12},
    		            {'name':'附件3：工法申报汇总表.xlsx','id':'filelist2','no':13}
    		            ];
    		        this.rselectedfiles = [];
    		        this.rselectedinfos = [];
    		        this.dialogVisible = true;
    		        this.rejectbatch = 1;
    		        
		        } else {
		            let data = {
    					status: 1
    				}
    				if(this.activerole == 'leader'){
    				    this.agreedialogVisible = true;
    				    this.rejectbatch = 1;
    				    return;
    				}
    				// console.log('opiniondata',Object.values(this.opiniondata))
				    // if( this.is_opinion_save == 1 &&  this.activerole != 'leader'){
    				//     this.$message.error('请填写评审意见')
    				// 	return false
    				// }
    				
    				//data['opiniondata'] = this.opiniondata;
                    this.$confirm("确认通过？")
                        .then((_) => {
                            expertgfbverify(data, this.selected_log_ids.join(',')).then(res => {
                                this.$message({
                                    message: "审核成功",
                                    type: "success",
                                })
                                this.initList(1);
                                this.getvalue();
                            }).catch(error => {
                                this.$message({
                                    message: error,
                                    type: "warning",
                                })
                            })
                        })
                        .catch((_) => {});
		        }
		    },
		    getDownloadFileName(response, fallback){
		        const headers = response && response.headers ? response.headers : {}
		        const disposition = headers['content-disposition'] || headers['Content-Disposition'] || ''
		        const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition)
		        if(match){
		            return decodeURIComponent(match[1] || match[2])
		        }
		        return fallback
		    },
		    saveBlobResponse(response, fallback){
		        const blob = response.data instanceof Blob ? response.data : new Blob([response.data])
		        const url = window.URL.createObjectURL(blob)
		        const link = document.createElement('a')
		        link.href = url
		        link.download = this.getDownloadFileName(response, fallback)
		        document.body.appendChild(link)
		        link.click()
		        document.body.removeChild(link)
		        window.URL.revokeObjectURL(url)
		    },
            batchExportSelectedScore(){
                if(this.activerole !== 'leader'){
                    this.$message.error('仅组长可导出专家意见')
                    return false
                }
                if(this.selected_log_ids.length === 0){
                    this.$message.error('请选择要导出的记录')
                    return false
                }
                expertAwardScoreBatchExport(this.selected_log_ids).then(response => {
                    this.saveBlobResponse(response, '工法专家评审表.xlsx')
                    this.$message.success('导出成功')
                }).catch(error => {
                    this.$message({
                        message: error && error.message ? error.message : error,
                        type: 'warning'
                    })
                })
            },
		    exportLeaderSummary(){
		        if(this.activerole !== 'leader'){
		            this.$message.error('仅组长可导出汇总表')
		            return false
		        }
		        if(!this.award_batch_id){
		            this.$message.error('请选择批次')
		            return false
		        }
		        const data = {
		            status: this.status,
		            wtype: this.wtype,
		            keyword: this.keyword
		        }
		        expertAwardSummaryExport(this.award_batch_id, data).then(response => {
		            this.saveBlobResponse(response, `工法专家评审汇总表_${this.award_batch_id}.xlsx`)
		            this.$message.success('导出成功')
		        }).catch(error => {
		            this.$message({
		                message: error && error.message ? error.message : error,
		                type: 'warning'
		            })
		        })
		    },
		    handlerole(){
		        this.initList(1);
		    },
		    handleSelectionChange(selection){
		       this.selected_log_ids = selection.map(item => item.id); // 获取所有选中行的 ID 数组
                console.log('[gf-review] selected ids', this.selected_log_ids);
		    },
		   
		    //驳回
		    handleReject(index, row){
                if (!this.canExpertReview(row)) {
                    this.$message.error('已退回或逾期终止的数据不可继续审核')
                    return false
                }
                if(this.activerole == 'leader'){
                    this.rejectbatch = 0;
                    this.rejectRow = row;
                    this.id = row.id;
                    this.reject = 6;
                    this.reason = this.getLeaderRejectReason(row);
                    this.reject_agreement = [];
                    this.dialogVisible = true;
                    return;
                }
                if (!this.canUseReject(row)) {
                    this.$message.error('当前专家已使用该记录的退回权限，不能重复退回')
                    return false
                }
		        this.rejectbatch = 0;
                this.rejectRow = row;
		        this.id = row.id;
		        this.reject = 7;
		        this.reason = '';
                this.rejectItemOpinions = {};
		        this.rejecttab = 'rinfo';
		        var info = row.content.info;
		        //组装工本信息
		        var author_names = info['author_names'].map(item => item['name']);
		        this.rinfos = [
		            {'name':'工程类别','value':info['type_of_work'],'id':'type_of_work'},
		            {'name':'专业分类','value':info['type_of_work'],'id':'type_of_major'},
		            {'name':'工法名称','value':info['name'],'id':'name'},
		            {'name':'企业注册地','value':this.getGongfaRegisterProvince(info, row),'id':'gf_province'},
		            {'name':'联系人及电话','value':info['username']+'/'+info['phone'],'id':'contact'},
		            {'name':'编写单位','value':info['unit'],'id':'unit'},
		            {'name':'完成人','value':author_names.join(','),'id':'author_names'},
		            {'name':'电话','value':info['tel'],'id':'tel'}
		            ];
		        //组装文件
		        this.rfiles = [
		            {'name':'《贵州省工程建设施工工法申报表》（附件1）','id':'filelist3','no':1},
		            {'name':'贵州省工程建设工法申报承诺书','id':'filelist_commitment','no':2},
		            {'name':'工法文本','id':'filelist4','no':3},
		            {'name':'企业工法证明材料','id':'filelist5','no':4},
		            {'name':'工法关键技术专家论证的有关资料','id':'filelist6','no':5},
		            {'name':'工程应用证明','id':'filelist7','no':6},
		            {'name':'经济效益证明（附件2）','id':'filelist8','no':7},
		            {'name':'工法应用的有关照片（10张以上）','id':'filelist12','no':8},
		            {'name':'由技术情报部门提供的科技查新报告','id':'filelist9','no':9},
		            {'name':'涉及他方专利的无争议声明书','id':'filelist10','no':10},
		            {'name':'关键技术标准、专利证书、科技成果获奖证明等其他有关材料','id':'filelist11','no':11},
		            {'name':'贵州省工程建设工法申报汇总表（附件3）PDF盖章版','id':'filelist1','no':12},
		            {'name':'附件3：工法申报汇总表.xlsx','id':'filelist2','no':13}
		            ];
		        this.rselectedfiles = [];
		        this.rselectedinfos = [];
		        this.dialogVisible = true;
		        // 等表格渲染完成后默认全选
                  this.$nextTick(() => {
                      console.log('this.$refs.rinfoTable?.toggleAllSelection',this.$refs.rinfoTable?.toggleAllSelection)
                      console.log('this.$refs.rinfoTable?',this.$refs.rinfoTable)
                      console.log('this.$refs.rinfoTable?.toggleRowSelection',this.$refs.rinfoTable?.toggleRowSelection)
                    // 如果你的 Element（UI/Plus）版本支持：
                    this.$refs.rinfoTable?.toggleAllSelection?.();
                    this.$refs.rfileTable?.toggleAllSelection?.();
                
                    // 保险做法（若无 toggleAllSelection），逐行选中：
                    if (this.$refs.rinfoTable?.toggleAllSelection == undefined && this.$refs.rinfoTable?.toggleRowSelection) {
                      this.rinfos.forEach(row => this.$refs.rinfoTable.toggleRowSelection(row, true));
                    }
                    if (this.$refs.rfileTable?.toggleAllSelection == undefined && this.$refs.rfileTable?.toggleRowSelection) {
                      this.rfiles.forEach(row => this.$refs.rfileTable.toggleRowSelection(row, true));
                    }
                
                    // 同步已选数据（也可依赖 @selection-change 自动触发）
                    this.handleRejectInfoChange(this.rinfos);
                    this.handleRejectFileChange(this.rfiles);
                  });
		    
		    },
            getReviewOpinionText(record){
                if(!record){
                    return ''
                }
                const opinion = record.checked_opinions || {}
                return opinion.rejection_reason || record.reject_reason || record.content || ''
            },
            getLeaderRejectReason(row){
                const parts = []
                const mainText = this.getReviewOpinionText(row && row.mainexpert)
                const secondText = this.getReviewOpinionText(row && row.reexpert)
                if(mainText){
                    parts.push(`主审意见：${mainText}`)
                }
                if(secondText){
                    parts.push(`副审意见：${secondText}`)
                }
                return parts.join('\n')
            },
            openReturnInitialDialog(row){
                if(!this.canLeaderReview(row)){
                    this.$message.warning('仅初审完成且待中审的记录可退回初审')
                    return false
                }
                this.returnInitialRow = row
                this.returnInitialExperts = []
                this.returnInitialVisible = true
            },
            handleReturnInitialClose(){
                this.returnInitialVisible = false
                this.returnInitialExperts = []
                this.returnInitialRow = null
            },
            submitReturnInitial(){
                if(!this.returnInitialRow){
                    this.$message.error('请选择退回记录')
                    return false
                }
                if(this.returnInitialExperts.length === 0){
                    this.$message.error('请选择退回专家')
                    return false
                }
                const data = buildReturnInitialPayload(this.returnInitialExperts, '', this.returnInitialRow)
                if(data.reject_expert_ids.length === 0){
                    this.$message.error('未找到可退回的专家')
                    return false
                }
                expertgfverify(data, this.returnInitialRow.id).then(res => {
                    this.$message({
                        message: '退回初审成功',
                        type: 'success'
                    })
                    this.handleReturnInitialClose()
                    this.initList(1)
                    this.getvalue()
                }).catch(error => {
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
		    handleRejectFileChange(files){
		        this.rselectedfiles = files;
                files.forEach(row => {
                    const key = this.getRejectOpinionKey('file', row);
                    if (this.rejectItemOpinions[key] === undefined) {
                        this.$set(this.rejectItemOpinions, key, '');
                    }
                });
		    },
		    handleRejectInfoChange(infos){
		        this.rselectedinfos = infos;
                infos.forEach(row => {
                    const key = this.getRejectOpinionKey('info', row);
                    if (this.rejectItemOpinions[key] === undefined) {
                        this.$set(this.rejectItemOpinions, key, '');
                    }
                });
		    },
            getRejectOpinionKey(type, row){
                return getRejectOpinionKey(type, row);
            },
            isRejectItemSelected(type, row){
                const selected = type === 'file' ? this.rselectedfiles : this.rselectedinfos;
                return selected.some(item => item.id === row.id);
            },
		    handleViewOpinion(row){
		       this.dialogOpinionVisible = true;
		       this.nrow = row;  
		    },
		    handlecstatus(){
		       this.initList(1);  
		    },
		    handleselectedbatch(){
		        console.log('this.award_batch_id',this.award_batch_id)
		        this.initList(1);  
		    },
            async getBatches(){
                let res = await AwardBatches(this.award_id);
                console.log('res.data',res)
                this.batches = res;
                this.searchYear = this.batches.length ? this.batches[0]['id'] : '';
                this.initList(1);
            },
			//分页
			getIndex($index) {
			    return $index + 1;
			},
			getpageValue(index) {
				this.initList(index);
			},
            downloadClick(type){
                this.exportType = type;
                this.timeRange = '';
                this.download = true;
            },
            exportInfo(){
                 let url = `${window.location.protocol}//${window.location.host}/api/home/review/award_log/export/9?token=${this.token}`;
                 if (this.timeRange) {
                     url = url + '&start_time='+this.dateFormat(this.timeRange[0],'yyyy-MM-dd') + '&end_time=' + this.dateFormat(this.timeRange[1],'yyyy-MM-dd');
                 }
                 url += '&type='+this.exportType;
                 console.log(url)
                 window.open(url);
            },
            handleUnitClose(done) {
                done();
            },
			handleModifyClose(done) {
				this.dialogTableVisible = false;
			},
			//1 提交 待分配 //2 初审 // 3 组长 //4 终审 //5 通过 6 不通过 7 驳回修改
			async initList(page) {
			    this.loading = true;
				const data = {
					pageSize: this.pageSize,
					page: page,
					award_batch_id: this.award_batch_id,
					cstatus: this.cstatus, // 0 待审核 1审核
					astatus: this.astatus, // 1 3个通过、2 3个驳回、3 1个通过、4 2个通过
					wtype:this.wtype,
					role:this.activerole,
					dates:this.dates,
					award_id:this.award_id
					
				};
                if(this.tableStatusFilter){
                    data.status = this.tableStatusFilter;
                }
                if (this.tableWtypeFilter) {
                    data.wtype = this.tableWtypeFilter;
                }
                if (!this.tableWtypeFilter && this.wtype) {
                    data.wtype = this.wtype;
                }
				console.log('data',data);
                if(this.searchYear){
                    data.year = this.searchYear;
                }
                if(this.keyword){
                    data.keyword = this.keyword;
                }
				let res = await expertawardgflogs(this.award_batch_id,data);
                
				this.formlist = res.data || [];
				this.formlist.forEach(e => {
					let year = e.created_at.slice(0, 4);
					e.year = e.award_batch.year+'-'+e.award_batch.batch;//(parseInt(year) - 1) + '-' + year;
                    if(e.award_id!=9||e.no==0){
                        e.no = e.id;
                    }
				})
				if(res.is_leader == 1){
				    this.activerole = 'leader';
				}
				this.total = res.total;
				this.loading = false;
                this.$nextTick(() => {
                    const selectionColumn = this.$el && this.$el.querySelector
                        ? this.$el.querySelector('.el-table-column--selection')
                        : null
                    console.log('[gf-review] initList render state', {
                        activerole: this.activerole,
                        cstatus: this.cstatus,
                        tableStatusFilter: this.tableStatusFilter,
                        rows: Array.isArray(this.formlist) ? this.formlist.length : 0,
                        selectableRows: Array.isArray(this.formlist) ? this.formlist.filter((row) => this.canLeaderReview(row)).length : 0,
                        selectionColumnExists: !!selectionColumn,
                    })
                })
                console.log('formlist',this.formlist);
			},
			getvalue() {
				this.step = 0;
				this.ischage = false;
				this.subtitle = "";
			},
			getapply(obj = {}, config = {}) {
                console.log(obj,'getapply');
				this.reAssign = config.reAssign || false
				if (obj.award && obj.award.title === '工程建设质量管理小组竞赛活动') {
					this.curObj = obj
					this.isShowAssignGroup = true
					return
				}
                this.dialogZJVisible = true;
                this.zjId = [];
                this.id = obj.id;
                getExpert().then(res => {
                    this.zjlist = res;
                })
			},
			toShowRejectRemark(row){
			    this.dialogRejectVisible = true;
			    this.nlog = row;
			    console.log('toShowRejectRemark',row)
			     //this.$message.error(row.checkedRemark);
			},
			toShowModify(row){
			     this.nlog = row;
			    console.log('toShowModify',row)
			    this.dialogTableVisible = true;
			},
            submitZJ(){
              //提交庄家
                let data = {
                    expert_ids:this.zjId
                }
                if(this.zjId.length<=0){
                    this.$message.error('请选择专家');
                    return;
                }

                setExpert(this.id,data).then(res => {
                    this.$message({
                        message: "保存成功",
                        type: "success",
                    })
                    this.zjId = [];
                    this.dialogZJVisible = false;
                    this.initList(1);
                    this.getvalue();
                }).catch(error => {
					this.$message({
						message: error,
						type: "warning",
					})
				});
            },
		    async toDetail(obj, rowindex, mode) {
                if (!this.canViewExpertRow(obj)) {
                    this.$message.error('已退回的数据不可查阅或审核')
                    return false
                }
                this.enterMode = mode || 'review';
                this.inRejectMode = false;
                this.activeName = this.enterMode === 'reject' ? 'first' : 'first';
                this.logAuditState('toDetail', { id: obj && obj.id, mode: this.enterMode });
			    const actualIndex = this.formlist.findIndex(item => item.id === obj.id);
			    this.rowindex = actualIndex !== -1 ? actualIndex : rowindex;
			    this.temUnitlist = [];
				console.log(obj)
                this.id = obj.id;
				this.parameters = obj.content
				const { award } = obj
				this.temformlist = [obj];
				this.ischage = true;
				this.is_opinion_save = 0;
				this.curObj = obj
				if(this.activerole == 'leader' || this.cstatus == 1){
				    this.is_opinion_view = 1;
				}
                this.temSupplementlist = [];
                console.log('this.parameters.info',this.parameters.info)
                const expertRecord = this.activerole === 'main' ? obj.mainexpert
                    : (this.activerole === 'leader' ? obj.leader : obj.reexpert);
                const parseNeedModifyRemark = (raw) => {
                    if (typeof raw === 'string') {
                        try { return JSON.parse(raw); } catch(e) { return raw; }
                    }
                    return raw;
                };
                const hasReturnModifyRemark = (remark) => {
                    if (!remark) return false;
                    if (Array.isArray(remark)) return remark.length > 0;
                    return !!(
                        (Array.isArray(remark.info) && remark.info.length > 0) ||
                        (Array.isArray(remark.files) && remark.files.length > 0) ||
                        (Array.isArray(remark.reject_items) && remark.reject_items.length > 0)
                    );
                };
                const getReturnLogReason = (log) => {
                    return log?.checkedRemark || log?.checked_remark || log?.reject_reason || log?.content || log?.reason || '';
                };
                const getReturnLogTime = (log) => {
                    return log?.checkedAt || log?.checked_at || log?.updated_at || log?.created_at || '';
                };
                let last_updated_at = '';
                let rejection_reason = '';

                // need_modify_remark 可能是 JSON 字符串（后端存储格式），先尝试解析
                let need_modify_remark_raw = expertRecord?.need_modify_remark;
                let need_modify_remark = parseNeedModifyRemark(need_modify_remark_raw);
                if (hasReturnModifyRemark(need_modify_remark)) {
                    last_updated_at = expertRecord?.updated_at || expertRecord?.created_at || '';
                    rejection_reason = expertRecord?.reject_reason || expertRecord?.content || '';
                }

                // 用户重提后专家记录会被重置为空数组，此时从 checkedlogs 取最近一次退回数据
                if (Array.isArray(obj.checkedlogs)) {
                    const expertId = expertRecord?.expert_id;
                    const rejLogs = obj.checkedlogs.filter(log =>
                        (!expertId || log.checker_id == expertId) &&
                        log.checked_status == 3 &&
                        hasReturnModifyRemark(parseNeedModifyRemark(log.need_modify_remark))
                    );
                    if (rejLogs.length > 0) {
                        const latestRejectLog = rejLogs[rejLogs.length - 1];
                        let src = parseNeedModifyRemark(latestRejectLog.need_modify_remark);
                        need_modify_remark = src;
                        last_updated_at = getReturnLogTime(latestRejectLog);
                        rejection_reason = getReturnLogReason(latestRejectLog);
                    }
                }
                this.last_rejection_reason = rejection_reason;
                console.log('[gf] need_modify_remark:', need_modify_remark);

                let last_need_modify_info = [];
                const lastOpinions = {};
                // 格式一：review管理员退回（info/files key）
                if (Array.isArray(need_modify_remark?.info)) {
                    for (let j = 0; j < need_modify_remark.info.length; j++) {
                        const item = need_modify_remark.info[j];
                        if (item.id) {
                            last_need_modify_info.push(item.id);
                            if (item.opinion) lastOpinions[item.id] = item.opinion;
                        }
                    }
                }
                // 格式二：专家在线退回（reject_items: [{item_id:'type_of_work', type:'info', opinion:'...'}, {item_id:'file:filelist4', ...}]）
                if (Array.isArray(need_modify_remark?.reject_items)) {
                    need_modify_remark.reject_items.forEach(item => {
                        if (!item || !item.item_id) return;
                        const parts = item.item_id.split(':');
                        const fieldId = parts.length === 2 ? parts[1] : item.item_id;
                        const type = parts.length === 2 ? parts[0] : (item.type || '');
                        if (type === 'info' || (!type && !fieldId.startsWith('filelist'))) {
                            if (last_need_modify_info.indexOf(fieldId) === -1) last_need_modify_info.push(fieldId);
                        }
                        if (item.opinion) lastOpinions[fieldId] = item.opinion;
                    });
                }

                this.last_updated_at = last_updated_at;
                this.last_need_modify.info = last_need_modify_info;
                this.lastRejectOpinions = lastOpinions;
                console.log('[gf] last_need_modify:', this.last_need_modify);
                console.log('[gf] lastRejectOpinions:', this.lastRejectOpinions);
                
                // 判断文件是否被标记需要修改（兼容 review管理员格式 和 专家在线退回格式）
                const gfFileIsError = (fieldId) => {
                    if (Array.isArray(need_modify_remark?.files) && need_modify_remark.files.indexOf(fieldId) !== -1) return 1;
                    if (Array.isArray(need_modify_remark?.reject_items)) {
                        return need_modify_remark.reject_items.some(item =>
                            item && (
                                item.item_id === 'file:' + fieldId ||
                                (item.item_id === fieldId && item.type === 'file')
                            )
                        ) ? 1 : 0;
                    }
                    return 0;
                };
				const safeUrl = (list) => (list && list[0] && list[0]['url']) ? list[0]['url'] : '';
				const mediaUrls = (list) => (Array.isArray(list) ? list : (list ? [list] : []))
					.map(file => ({ url: file && file.url, name: file && file.name }))
					.filter(file => file.url);
				const info = this.parameters.info;

				// 文件顺序按要求排列（带 opinion 字段）
				const pushFile = (id, no, name, url, urls = []) => {
					this.temUnitlist.push({id, no, name, url, urls, is_error: gfFileIsError(id), opinion: lastOpinions[id] || ''});
                };
                pushFile('filelist3', 1, '《贵州省工程建设工法申报表》', safeUrl(info.filelist3));
                pushFile('filelist_commitment', 2, '工法申报承诺书', safeUrl(info.filelist_commitment));
                pushFile('filelist4', 3, '完整工法文本', safeUrl(info.filelist4));
                pushFile('filelist5', 4, '企业级工法批准发布文件', safeUrl(info.filelist5));
                pushFile('filelist6', 5, '关键技术专家论证材料', safeUrl(info.filelist6));
                pushFile('filelist7', 6, '工程应用证明材料', safeUrl(info.filelist7));
                pushFile('filelist8', 7, '经济效益证明', safeUrl(info.filelist8));
				pushFile('filelist12', 8, '工法现场应用照片不少于 10张，可附短视频资料', safeUrl(info.filelist12), mediaUrls(info.filelist12));
                pushFile('filelist9', 9, '科技查新报告', safeUrl(info.filelist9));
                pushFile('filelist10', 10, '涉及第三方专利的提交无争议声明', safeUrl(info.filelist10));
                pushFile('filelist11', 11, '专利证书、成果获奖等其他佐证材料', safeUrl(info.filelist11));
                pushFile('filelist1', 12, '贵州省工程建设工法申报汇总表', safeUrl(info.filelist1));
                pushFile('filelist2', 13, '贵州省建设工法申报汇总表xlsx版', safeUrl(info.filelist2));

                if (this.activerole === 'leader') {
                    this.leaderRecommend = null
                    this.lroption = 'leader_tab'
                    this.initLeaderDefaultOpinion(obj)
                }

                // let tmainopiniondata = obj.primary_checked_opinions;
                // this.mainopiniondata = [
                //         // —— 申报条件审查 —— //
                //         { type:'normal', project:'申报条件审查', category:'工法名称', standard:'内容名称是否一致，工法是否与过去批准工法相同', content:tmainopiniondata['name_match'] },
                //         { type:'normal', project:'申报条件审查', category:'企业级工法审查', standard:'审批部门原件审查，提供无争议证明', content:tmainopiniondata['enterprise_approval'] },
                //         { type:'normal', project:'申报条件审查', category:'工法主要完成单位及完成人审查', standard:'主要完成单位和主要完成人，必须是企业批准文件公布之列。', content:tmainopiniondata['main_units_members'] },
                //         { type:'normal', project:'申报条件审查', category:'省外企业申报的工法审查', standard:'工程实例是否有贵州工程', content:tmainopiniondata['outside_province'] },
                //         { type:'normal', project:'申报条件审查', category:'关键技术鉴定证书审查、效益证明审查', standard:'专家委员会组成是否符合，证书内容是否齐全；效益证明是否有效真实', content:tmainopiniondata['key_certificates'] },
                
                //         // —— 工法文本审查 —— //
                //         { type:'normal', project:'工法文本审查', category:'工法名称与内容审查', standard:'名称与内容是否贴切，能否直观反映工法名称', content:tmainopiniondata['name_content_match'] },
                //         { type:'normal', project:'工法文本审查', category:'工法的叙述层次排列', standard:'工法是否按 章、节、条款、项、层次排列', content:tmainopiniondata['hierarchy_order'] },
                //         { type:'normal', project:'工法文本审查', category:'工法中表格、插图审查', standard:'表格、图应有名称，图表应有文字描述及编号', content:tmainopiniondata['table_figures'] },
                //         { type:'normal', project:'工法文本审查', category:'工法特点审查', standard:'使用功能或施工方法上的特点、先进性和创新性', content:tmainopiniondata['features'] },
                
                //         // —— 编写内容审查 —— //
                //         { type:'normal', project:'编写内容审查', category:'工法内容审查', standard:'材料与设备、质量安全、经济效益', content:tmainopiniondata['content_items'] },
                //         { type:'normal', project:'编写内容审查', category:'适用范围审查', standard:'采用该工法的工程对象或工程部位', content:tmainopiniondata['scope'] },
                //         { type:'normal', project:'编写内容审查', category:'环保节能审查', standard:'环保节能措施及效果', content:tmainopiniondata['environment'] },
                //         { type:'normal', project:'编写内容审查', category:'工艺原理审查', standard:'关键技术基本原理是什么？特点是什么？其安全性和可靠性？', content:tmainopiniondata['principle'] },
                //         { type:'normal', project:'编写内容审查', category:'应用实例', standard:'工程名称、合同、鉴定或提供成熟可靠性证书', content:tmainopiniondata['cases'] },
                //         { type:'normal', project:'编写内容审查', category:'工艺流程及操作要求审查', standard:'讲清基本工艺过程、工序衔接；工艺水平达到什么程度', content:tmainopiniondata['process_req'] },
                //         { type:'normal', project:'编写内容审查', category:'工艺流程及操作要点阐述全面，工序衔接合理，该施工技术达到省内领先水平', standard:'关键技术证明：（专利号、专利权人）', content:tmainopiniondata['process_keypoints'] },
                
                //         // —— 整行说明 / 问答 —— //
                //         { type:'full', fullLabel:'审查人意见' },
                //         { type:'full', fullLabel:'工法关键技术水平？', content:tmainopiniondata['key_tech_level'] },
                //         { type:'full', fullLabel:'是否适用于省内工程？' , content:tmainopiniondata['suitable_in_province']},
                //         { type:'full', fullLabel:'是否同意推荐为省级工法？', content:tmainopiniondata['recommend_provincial'] }, // 空白行（可去掉）
                //         { type:'full', fullLabel:'不通过的充分理由（如同意可忽略）', content:tmainopiniondata['rejection_reason'] },
                //       ];
                      
                // let treopiniondata = obj.secondary_checked_options;
                // this.reopiniondata = [
                //         // —— 申报条件审查 —— //
                //         { type:'normal', project:'申报条件审查', category:'工法名称', standard:'内容名称是否一致，工法是否与过去批准工法相同', content:treopiniondata['name_match'] },
                //         { type:'normal', project:'申报条件审查', category:'企业级工法审查', standard:'审批部门原件审查，提供无争议证明', content:treopiniondata['enterprise_approval'] },
                //         { type:'normal', project:'申报条件审查', category:'工法主要完成单位及完成人审查', standard:'主要完成单位和主要完成人，必须是企业批准文件公布之列。', content:treopiniondata['main_units_members'] },
                //         { type:'normal', project:'申报条件审查', category:'省外企业申报的工法审查', standard:'工程实例是否有贵州工程', content:treopiniondata['outside_province'] },
                //         { type:'normal', project:'申报条件审查', category:'关键技术鉴定证书审查、效益证明审查', standard:'专家委员会组成是否符合，证书内容是否齐全；效益证明是否有效真实', content:treopiniondata['key_certificates'] },
                  
                //         // —— 工法文本审查 —— //
                //         { type:'normal', project:'工法文本审查', category:'工法名称与内容审查', standard:'名称与内容是否贴切，能否直观反映工法名称', content:treopiniondata['name_content_match'] },
                //         { type:'normal', project:'工法文本审查', category:'工法的叙述层次排列', standard:'工法是否按 章、节、条款、项、层次排列', content:treopiniondata['hierarchy_order'] },
                //         { type:'normal', project:'工法文本审查', category:'工法中表格、插图审查', standard:'表格、图应有名称，图表应有文字描述及编号', content:treopiniondata['table_figures'] },
                //         { type:'normal', project:'工法文本审查', category:'工法特点审查', standard:'使用功能或施工方法上的特点、先进性和创新性', content:treopiniondata['features'] },
               
                //         // —— 编写内容审查 —— //
                //         { type:'normal', project:'编写内容审查', category:'工法内容审查', standard:'材料与设备、质量安全、经济效益', content:treopiniondata['content_items'] },
                //         { type:'normal', project:'编写内容审查', category:'适用范围审查', standard:'采用该工法的工程对象或工程部位', content:treopiniondata['scope'] },
                //         { type:'normal', project:'编写内容审查', category:'环保节能审查', standard:'环保节能措施及效果', content:treopiniondata['environment'] },
                //         { type:'normal', project:'编写内容审查', category:'工艺原理审查', standard:'关键技术基本原理是什么？特点是什么？其安全性和可靠性？', content:treopiniondata['principle'] },
                //         { type:'normal', project:'编写内容审查', category:'应用实例', standard:'工程名称、合同、鉴定或提供成熟可靠性证书', content:treopiniondata['cases'] },
                //         { type:'normal', project:'编写内容审查', category:'工艺流程及操作要求审查', standard:'讲清基本工艺过程、工序衔接；工艺水平达到什么程度', content:treopiniondata['process_req'] },
                //         { type:'normal', project:'编写内容审查', category:'工艺流程及操作要点阐述全面，工序衔接合理，该施工技术达到省内领先水平', standard:'关键技术证明：（专利号、专利权人）', content:treopiniondata['process_keypoints'] },
                
                //         // —— 整行说明 / 问答 —— //
                //         { type:'full', fullLabel:'审查人意见' },
                //         { type:'full', fullLabel:'工法关键技术水平？', content:treopiniondata['key_tech_level'] },
                //         { type:'full', fullLabel:'是否适用于省内工程？' , content:treopiniondata['suitable_in_province']},
                //         { type:'full', fullLabel:'是否同意推荐为省级工法？', content:treopiniondata['recommend_provincial'] }, // 空白行（可去掉）
                //         { type:'full', fullLabel:'不通过的充分理由（如同意可忽略）', content:treopiniondata['rejection_reason'] },
                //       ];
                console.log('this.activerole',this.activerole)
                var opiniondata = this.activerole == 'main' ? obj.mainexpert?.checked_opinions : (this.activerole == 'leader' ? obj.leader?.checked_opinions : obj.reexpert?.checked_opinions);
                console.log('this.opiniondata2',opiniondata)
                this.checkedlogs = await echeckedlogs(obj.id);
                //this.temSupplementlist = [];
				this.step = 1;
                if(opiniondata != null){
                    this.opiniondata = opiniondata;//.name_match == undefined ? {} : opiniondata;
                    this.is_opinion_save = opiniondata.isFinished == undefined ? 0 : opiniondata.isFinished;
                } else {
                    this.opiniondata = { 'name_match':'','enterprise_approval':'','outside_province':'','name_content_match':'','hierarchy_order':'','table_figures':'','features':'','content_items':'','scope':'','environment':'','cases':'','process_keypoints':'','key_tech_level':'','suitable_in_province':'','recommend_provincial':'','rejection_reason':'','main_units_members':''}
                }
                
                console.log('opiniondata',this.opiniondata);
                

			},
            toUnitDetail(obj){
                console.log(obj,'toUnitDetail')
                this.unit = obj;
                this.dialogUnitVisible = true;
            },
			//通过
			handleEdit(a, b) {
                if (!this.canExpertReview(b)) {
                    this.$message.error('已退回或逾期终止的数据不可继续审核')
                    return false
                }
			    if(this.activerole == 'leader'){
			        this.agreedialogVisible = true;
    			    this.agreerow = b;
    			    return;
			    }
			    
				console.log('this.is_opinion_save',this.is_opinion_save)
				console.log('opiniondata',Object.values(this.opiniondata))
				if( this.is_opinion_save != 1 &&  this.activerole != 'leader'){
				    this.$message.error('请先完成评审意见并确认评审内容已保存')
					return false
				}
				let data
				try {
				    data = buildReviewDecisionFromOpinion(this.opiniondata)
				} catch (error) {
				    this.$message.error(error.message)
				    return false
				}
				
				//data['opiniondata'] = this.opiniondata;
                this.$confirm(data.status === 1 ? "确认通过？" : "确认不推荐？")
                    .then((_) => {
                        expertgfverify(data, b.id).then(res => {
                            this.$message({
                                message: "审核成功",
                                type: "success",
                            })
                            this.initList(1);
                            this.getvalue();
                        }).catch(error => {
                            this.$message({
                                message: error,
                                type: "warning",
                            })
                        })
                    })
                    .catch((_) => {});
			},
			//立即提交
	        enterRejectMode() {
                const row = this.temformlist[0]
                const info = row && row.content && row.content.info
                if (info) {
                    const authorNames = (info.author_names || []).map(a => a.name).join('、')
                    this.rinfos = [
                        {name: '工程类别', value: info.type_of_work || '', id: 'type_of_work'},
                    {name: '专业分类', value: info.type_of_major || '', id: 'type_of_major'},
                    {name: '工法名称', value: info.name || '', id: 'name'},
                    {name: '编写单位', value: info.unit || '', id: 'unit'},
                    {name: '企业注册地', value: this.getGongfaRegisterProvince(info, row), id: 'gf_province'},
                    {name: '联系人及电话', value: (info.username || '') + '/' + (info.phone || ''), id: 'contact'},
                        {name: '完成人', value: authorNames, id: 'author_names'},
                    ]
                }
                this.inRejectMode = true
                this.activeName = 'first'
                this.rejecttab = 'rfile'
                this.logAuditState('enterRejectMode', { id: row && row.id });
                this.rselectedfiles = []
                this.rselectedinfos = []
                this.rejectItemOpinions = {}
                this.inlineFileOpinions = {}
                this.inlineInfoOpinions = {}
                this.selectedInfoIds = {}
                this.reject = 7
                this.rejectRow = this.temformlist[0]
                this.rejectbatch = 0
                this.reason = ''
            },
            cancelRejectMode() {
                this.inRejectMode = false
                this.rselectedfiles = []
                this.inlineFileOpinions = {}
                this.inlineInfoOpinions = {}
                this.selectedInfoIds = {}
                this.logAuditState('cancelRejectMode', { id: this.temformlist[0] && this.temformlist[0].id });
            },
            getLinkedFileIds(fileId) {
                if (fileId === 'filelist1' || fileId === 'filelist2') {
                    return ['filelist1', 'filelist2']
                }
                return [fileId]
            },
            ensureSelectedFile(row) {
                if (!row) return
                if (!this.rselectedfiles.find(f => f.id === row.id)) {
                    this.rselectedfiles.push({ id: row.id, no: row.no, name: row.name })
                }
                if (this.inlineFileOpinions[row.id] === undefined) {
                    this.$set(this.inlineFileOpinions, row.id, '')
                }
            },
            removeSelectedFile(fileId) {
                this.rselectedfiles = this.rselectedfiles.filter(f => f.id !== fileId)
                this.$delete(this.inlineFileOpinions, fileId)
            },
            handleFileCheckChange(checked, row) {
                const linkedIds = this.getLinkedFileIds(row.id)
                if (checked) {
                    linkedIds.forEach(fileId => {
                        const targetRow = this.temUnitlist.find(item => item.id === fileId)
                        if (targetRow) this.ensureSelectedFile(targetRow)
                    })
                    return
                }
                linkedIds.forEach(fileId => this.removeSelectedFile(fileId))
            },
            onInfoFieldCheck(checked, field) {
                this.$set(this.selectedInfoIds, field.id, checked)
                if (!checked) this.$delete(this.inlineInfoOpinions, field.id)
            },
            fileTableCellStyle({ columnIndex }) {
                if (columnIndex === 1) {
                    return { 'text-align': 'left', padding: '10px 12px' };
                }
                return { 'text-align': 'center' };
            },
            fileTableHeaderCellStyle({ columnIndex }) {
                const base = { background: '#F5F6F7', color: '#808895' };
                if (columnIndex === 1) {
                    return { ...base, 'text-align': 'left', 'padding-left': '12px' };
                }
                return { ...base, 'text-align': 'center' };
            },
            handleInlineFileSelectionChange(selection) {
                this.rselectedfiles = selection.map(row => ({ id: row.id, no: row.no, name: row.name }))
            },
            confirmInlineReject() {
                // 构建 rselectedinfos
                this.rselectedinfos = (this.rinfos || []).filter(f => this.selectedInfoIds[f.id])
                const totalSelected = this.rselectedfiles.length + this.rselectedinfos.length
                if (totalSelected === 0) {
                    this.$message.error('请至少勾选一项需要修改的材料或信息')
                    return
                }
                // 验证文件每项已填写意见
                for (const f of this.rselectedfiles) {
                    if (!this.inlineFileOpinions[f.id] || !String(this.inlineFileOpinions[f.id]).trim()) {
                        this.$message.error(`请填写「${f.name}」的修改意见`)
                        return
                    }
                }
                // 验证工法信息每项已填写意见
                for (const f of this.rselectedinfos) {
                    if (!this.inlineInfoOpinions[f.id] || !this.inlineInfoOpinions[f.id].trim()) {
                        this.$message.error(`请填写「${f.name}」的修改意见`)
                        return
                    }
                }
                // 合并 opinions
                this.rejectItemOpinions = {}
                Object.keys(this.inlineFileOpinions).forEach(fileId => {
                    this.$set(this.rejectItemOpinions, `file:${fileId}`, this.inlineFileOpinions[fileId])
                })
                this.rselectedinfos.forEach(f => {
                    this.$set(this.rejectItemOpinions, `info:${f.id}`, this.inlineInfoOpinions[f.id])
                })
                this.logAuditState('confirmInlineReject', {
                    selectedFiles: this.rselectedfiles.map(item => item.id),
                    selectedInfos: this.rselectedinfos.map(item => item.id),
                });
                this.rejectsumbit()
            },
            initLeaderDefaultOpinion(obj) {
                const getRejectReason = (expertRec) => {
                    if (!expertRec) return ''
                    let op = expertRec.checked_opinions
                    if (typeof op === 'string') { try { op = JSON.parse(op) } catch(e) {} }
                    if (!op) return ''
                    const pass = op.recommend_provincial && op.recommend_provincial.pass
                    if (pass === false || pass === 0 || pass === '0' || pass === 'false') {
                        return String(op.rejection_reason || '').trim()
                    }
                    return ''
                }
                const reasons = [
                    getRejectReason(obj && obj.mainexpert),
                    getRejectReason(obj && obj.reexpert),
                ].filter(Boolean)
                this.leaderOpinion = reasons.join('\n')
            },
            doSubmitLeaderReview() {
                if (this.leaderRecommend === null) {
                    this.$message.error('请选择审核结果')
                    return
                }
                if (this.leaderRecommend === false && !String(this.leaderOpinion || '').trim()) {
                    this.$message.error('不推荐时审核意见必填')
                    return
                }
                const row = this.curObj
                if (!row || !row.id) { this.$message.error('数据异常'); return }
                const data = {
                    status: this.leaderRecommend ? 1 : 2,
                    reject_reason: String(this.leaderOpinion || '').trim(),
                }
                this.$confirm(this.leaderRecommend ? '确认推荐？' : '确认不推荐？')
                    .then(() => {
                        expertgfverify(data, row.id).then(() => {
                            this.$message({ message: '审核成功', type: 'success' })
                            this.initList(1)
                            this.getvalue()
                        }).catch(err => {
                            this.$message({ message: err, type: 'warning' })
                        })
                    }).catch(() => {})
            },
            doSubmitMainReview() {
                const opinionPayload = this.getCurrentReviewOpinionPayload()
                if (!opinionPayload || !Object.keys(opinionPayload).length) {
                    this.$message.error('请先完成评审意见')
                    return
                }
                // 调用 ReviewOpinionSheet 的 validate() 检查是否全部填写
                const sheet = this.$refs.mainReviewOpinionSheet
                if (sheet && typeof sheet.validate === 'function') {
                    const missing = sheet.validate()
                    if (missing.length > 0) {
                        this.$message.error('以下项目未填写：' + missing[0] + (missing.length > 1 ? ` 等 ${missing.length} 项` : ''))
                        return
                    }
                } else if (!opinionPayload.isFinished) {
                    this.$message.error('请完成所有评审意见项后再提交')
                    return
                }
                this.opiniondata = opinionPayload
                const pass = opinionPayload?.recommend_provincial?.pass
                const isRecommend = normalizeRecommendDecision(pass)
                const reason = opinionPayload?.rejection_reason || ''
                this.logAuditState('doSubmitMainReview:payload', {
                    pass,
                    isRecommend,
                    reason,
                });
                if (isRecommend === false && !String(reason).trim()) {
                    this.$message.error('不推荐时请填写不推荐的理由')
                    return
                }
                if (isRecommend !== true && isRecommend !== false) {
                    this.$message.error('请选择是否推荐')
                    return
                }
                this.logAuditState('doSubmitMainReview', {
                    isRecommend,
                    hasReason: !!String(reason).trim(),
                });
                const status = isRecommend ? 1 : 2
                const data = {
                    status,
                    reject_reason: String(reason).trim(),
                    opiniondata: opinionPayload
                }
                this.$confirm(isRecommend ? '确认同意推荐？' : '确认不推荐？').then(() => {
                    expertgfverify(data, this.id).then(() => {
                        this.$message({ message: '提交成功', type: 'success' })
                        this.initList(1)
                        this.getvalue()
                    }).catch(error => {
                        this.$message({ message: error, type: 'warning' })
                    })
                }).catch(() => {})
            },
            openApproveDialog(row) {
                if (this.activerole !== 'leader') {
                    // 主审/副审：使用简单提交弹窗
                    this.agreerow = row
                    this.id = row.id
                    this.mainReviewResult = '1'
                    this.mainReviewReason = ''
                    this.mainReviewVisible = true
                } else {
                    // 组长：使用原有弹窗
                    this.agreerow = row
                    this.id = row.id
                    this.reject = 6
                    this.reason = ''
                    this.reject_agreement = []
                    this.agreedialogVisible = true
                }
            },
		rejectsumbit() {
                if (this.rejectbatch != 1 && this.rejectRow) {
                    if (!this.canExpertReview(this.rejectRow)) {
                        this.$message.error('已退回或逾期终止的数据不可继续审核')
                        return false
                    }
                    if (!this.canUseReject(this.rejectRow)) {
                        this.$message.error('当前专家已使用该记录的退回权限，不能重复退回')
                        return false
                    }
                }
				let rejectItems = []
				if (this.reject != 6) {
                    const validation = validateRejectItems(this.rselectedinfos, this.rselectedfiles, this.rejectItemOpinions);
                    if (!validation.valid) {
                        this.$message.error(validation.message)
                        return false
                    }
                    rejectItems = validation.items
                } else if (this.reason == "") {
					this.$message.error('请填写驳回原因')
					return false
				}
                const rejectReason = this.reason || rejectItems.map(item => `${item.name}：${item.opinion}`).join('\n')
				let data = {
					status: this.reject == 6 ? 2 : 3,
                    reject_reason: rejectReason,
                    rinfos:this.rselectedinfos,
                    rfiles:this.rselectedfiles,
                    reject_items: rejectItems,
                    checked_agreement:this.reject_agreement
				}
    // 			if( ( Object.values(this.opiniondata).length < 19 || (Object.values(this.opiniondata).length == 19 && this.opiniondata['rejection_reason'] != '' ) ) && this.activerole != 'leader'){
				//     this.$message.error('请填写评审意见')
				// 	return false
				// }
				if( this.reject != 7 && this.is_opinion_save != 1 &&  this.activerole != 'leader'){
				    this.$message.error('请先完成评审意见并确认评审内容已保存')
					return false
				}
				//data['opiniondata'] = this.opiniondata;
				if(this.rejectbatch == 1){
				    	expertgfbverify(data, this.selected_log_ids.join(',')).then(res => {
        					this.$message({
        						message: "提交成功",
        						type: "success",
        					})
                            this.reason = '';
                            this.dialogVisible = false;
                            this.inRejectMode = false;
                            this.initList(1);
                            this.getvalue();
        				}).catch(error => {
                            this.dialogVisible = false;
        					this.$message({
        						message: error,
        						type: "warning",
        					})
                            this.reason = '';
        				})
        				this.reject_agreement = []
                        this.rejectbatch = 0;
                            
				} else {
				    expertgfverify(data, this.id).then(res => {
    					this.$message({
    						message: "提交成功",
    						type: "success",
    					})
                        this.reason = '';
                        this.dialogVisible = false;
                        this.initList(1);
                        this.getvalue();
                        this.reject_agreement = []
    				}).catch(error => {
                        this.dialogVisible = false;
    					this.$message({
    						message: error,
    						type: "warning",
    					})
                        this.reason = '';
    				})
				}
				
			},
			//不予通过
			handleDelete(a, b) {
				this.dialogVisible = true;
				this.user = b.user
				this.id = b.id
				this.created_at = b.created_at;
			},
            resetQuery() {
                this.searchYear = '';
                this.keyword = '';
                this.award_id = 0;
                this.tableStatusFilter = '';
                this.tableColumnFilters = {};
                this.tableWtypeFilter = '';
                this.wtype = '';
                this.loading = true;
                this.initList(1);
            },
            handleQuery(){
                this.loading = true;
                this.initList(1);
            },
            handleStatusFilterChange(filters){
                this.tableColumnFilters = filters || {}
                const reviewStatus = this.tableColumnFilters.reviewStatus || []
                const wtype = this.tableColumnFilters.wtype || []
                this.tableStatusFilter = reviewStatus.length ? reviewStatus[0] : ''
                this.tableWtypeFilter = wtype.length ? wtype[0] : ''
                this.loading = true
                this.initList(1)
            },
            dateFormat(date,fmt) {
                let ret
                const opt = {
                    'y+': date.getFullYear().toString(), // 年
                    'M+': (date.getMonth() + 1).toString(), // 月
                    'd+': date.getDate().toString(), // 日
                    'H+': date.getHours().toString(), // 时
                    'm+': date.getMinutes().toString(), // 分
                    's+': date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                }
                for (let k in opt) {
                    ret = new RegExp('(' + k + ')').exec(fmt)
                    if (ret) {
                        fmt = fmt.replace(
                            ret[1],
                            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
                        )
                    }
                }
                return fmt
            },
			viewRejectReason(row) {
				this.$alert(row.reject_reason, '驳回理由', {
					confirmButtonText: '确定'
				});
			},
			buildRowspanMap(list, key) {
              const span = []
              let i = 0
              while (i < list.length) {
                if (list[i].type !== 'normal') { // full 行：不参与纵向合并
                  span[i] = 1
                  i++
                  continue
                }
                let j = i + 1
                while (
                  j < list.length &&
                  list[j].type === 'normal' &&
                  list[j][key] === list[i][key]
                ) j++
                const len = j - i
                span[i] = len
                for (let k = i + 1; k < j; k++) span[k] = 0
                i = j
              }
              return span
            },
        
            // 合并规则
            spanMethod({ row, rowIndex, columnIndex }) {
              // 整行横跨：只显示第 0 列，其它列隐藏
              if (row.type === 'full') {
                if (columnIndex === 0) {
                  // 把“整行标题”放在第一列显示，其它列隐藏
                  row.project = row.fullLabel
                  row.category = ''
                  row.standard = ''
                  row.content  = ''
                  return { rowspan: 1, colspan: 4 }
                }
                return { rowspan: 0, colspan: 0 }
              }
        
              // 普通行合并“审查项目”（第 0 列）
              if (columnIndex === 0) {
                const rowspan = this.projectSpan[rowIndex]
                return { rowspan, colspan: rowspan > 0 ? 1 : 0 }
              }
        
              return { rowspan: 1, colspan: 1 }
            },
        
            // 样式
            cellStyle() {
              return {
                'white-space': 'normal',
                'word-break': 'break-all',
                'line-height': '20px',
                'padding': '8px 10px',
                'vertical-align': 'middle'
              }
            },
            headerCellStyle() {
              return { 'text-align': 'center', 'font-weight': '600' }
            }
		},
	};
</script>

<style>
.el-table .cell {
    width:100% !important;
}
.form_title {
    align-items: center;
}
.binfobase .my_form2 {
    margin-bottom:0px !important;
    height: auto !important;
    margin-bottom: 0px !important;
    border-bottom: 1px solid #DDD;
     padding-top: 0px !important; 
     padding-bottom: 0px !important; 
    padding-left: 20px;
    
}
.binfobase .form_title {
    width: 150px !important;
        border-right: 1px solid #ddd;
    height: 50px !important;
    line-height: 50px  !important;
}
.binfobase .form_content {
        padding-left: 10px;
        height: 50px;
    line-height: 50px;
    width:calc(100% - 220px)!important;
        
}
.batchsearch input {
    border:0px !important;
}
.topnavs {
        position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    border-bottom: 1px solid #DDDDDD;
}
	.el-tabs__header {
		width: 100% !important;
	}
    .divZJ{
        text-align: left;overflow:auto;
    }
</style>
<style lang="less" scoped>
.tuibtn {
        width: auto !important; 
       height: auto !important; 
        background: #194ABE;
        border-radius: 8px 8px 8px 8px;
        font-weight: 500;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
        padding: 10px 40px;
}
.otheader{
    width:100%;
    font-size: 16px;
    color: #262626;
    text-align:center;
    display:flex;
    flex-direction:row;
    background: #F9FAFF;
    
}
.otitem {
    background: #F0F4FF;
    font-size: 14px;
    color: #262626;
    display: flex;
}
.othno, .otno {
    width:100px;
    text-align:center;
    padding-top:10px;
    padding-bottom:10px;
    border-right: 1px solid #DDDDDD;
}
.othleimu,.otleimu {
    width:200px;
    text-align:center;
     padding-top:10px;
    padding-bottom:10px;
    border-right: 1px solid #DDDDDD;
}
.othyaoqiu,.otyaoqiu {
    text-align:center;
    padding-top:10px;
    padding-bottom:10px;
    width:calc(100% - 300px);
}
.otinput .otextarea {
    width:100%;
}
.checkeddiv {
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #D9D9D9;
        padding:20px;
    }
.sms-fail-badge {
    background:#FF3041;
    padding:4px 8px;
    font-weight:400;
    font-size:12px;
    color:#FFFFFF;
    line-height:24px;
    cursor:pointer;
    margin-bottom:4px;
    display:inline-block;
}
    .ctitle {
        font-weight: 700;
        font-size: 16px;
        color: #262626;
        margin-bottom: 10px;
        text-align: left;
    }
    .cval {
        font-weight: 400;
        font-size: 18px;
        color: #262626;
        text-align: left;
        margin-bottom:20px;
    }
	/deep/.block-title {
		border-left: 3px solid #194abe !important;
	}

	.yellow-box {
		height: 40px;
		background: #FEF8EF;
		opacity: 1;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;

		span {
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			line-height: 24px;

			&:nth-child(1) {
				color: #194ABE;
			}

			&:nth-child(2) {
				color: #0C0D0F;
			}

			&:nth-child(3) {
				color: #7C828A;
				font-size: 14px;
			}
		}
	}

	.reason {
		/*margin-top: 20px;*/
		width: 100%;
		height: 162px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 4px;
		outline: none;
		padding: 10px;
		box-sizing: border-box;
		border:  0px !important;
	}

	.textarea {
		width: 382px;
		// height: 92px;
		background: #ffffff;
		border: 1px solid #bdc3cb;
		opacity: 1;
		border-radius: 4px;
	}

	.block-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin: 20px 0;

		&-item {
			width: 370px;
			background: #ffffff;
			border: 1px dashed #c8cdd5;
			padding: 24px 25px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-bottom: 21px;
			position: relative;

			&-r-t {
				position: absolute;
				top: 0;
				right: 0;
				width: 73px;
				height: 27px;
				background: #f5f9fb;
				opacity: 1;
				border-radius: 0px 0px 0px 80px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				line-height: 27px;
				color: #c6c9ce;
				padding-left: 10px;
				box-sizing: border-box;
			}

			&-box {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				align-items: flex-start;

				&-t {
					width: 244px;
					color: #0c0d0f;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-align: justify;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
				}

				&-dtae {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					line-height: 26px;
					color: #194abe;
				}

				&-startend {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					line-height: 26px;
					color: #7c828a;
				}

				&-b {
					width: 91px;
					height: 32px;
					background: #ffffff;
					border: 1px solid #194abe;
					color: #194abe;
					opacity: 1;
					border-radius: 6px;
					text-align: center;
					line-height: 32px;
					font-size: 14px;
					cursor: pointer;
				}

				&-b-d {
					background: #ffffff !important;
					border: 1px solid #d4dbdd !important;
					color: #c8cdd5 !important;
				}

				&-b-s {
					background: #d4dbdd !important;
					border: 1px solid #d4dbdd !important;
					color: #ffffff !important;
				}
			}
		}
	}

	.margin-bottom-40 {
		margin-bottom: 40px;
	}

	.infor {
		padding-bottom: 40px;
		min-height: 800px;
		margin-bottom: 34px;
		position: relative;
	}

	.upload-demo {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.uploadheader {
		height: 60px;
		width: 100%;
		display: flex;
		align-items: center;

		span {
			margin-right: 10px;
			color: #71767c;
		}
	}

	.margin-top-40 {
		margin-top: 40px;
	}

	.block-solid {
		width: 100%;
		height: 2px;
		background-color: #e51725;
		margin-top: 30px;
	}

	.shenhjrkr {
		margin: 71px 0 100px 0;

		img {
			width: 120px;
		}
	}
	.block-addr {
		display: inline-block;
		padding: 13px 32px;
		background-color: #fff7e8;
		font-size: 14px;
		margin-top: 31px;

		.span-l {
			color: #9fa5ae;
		}

		.span-r {
			color: #194abe;
		}
	}
	.pform_title {
	    font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 700;
        line-height: 20px;
        color: #0c0d0f;
        text-align: left;
	}
	.form_right {
	      width: 860px;
	      .flex {
	        display: flex;
	      }
	      .flex-direction {
	        flex-direction: column;
	      }
	      .form_1 {
	        width: 100%;
	        background: #ffffff;
	        padding: 35px 30px;
	        box-sizing: border-box;
	        margin-bottom: 30px;
	        border-radius: 6px;

			.form_dec {
				text-align: left;
				margin-top: 20px;
			}

	        .border {
	          border-top: 1px dashed #9fa5ae;
	          margin: 20px 0;
	        }
	        .bord {
	          margin-top: 11px;
	          width: 858px;
	          height: 0px;
	          border: 1px solid #194abe;
	          position: relative;
	          img {
	            width: 11px;
	            height: 6px;
	            position: absolute;
	            top: -6px;
	            left: 37px;
	          }
	        }
	        .newlybuild {
	          margin: 0 auto;
	          cursor: pointer;
	          width: 221px;
	          height: 36px;
	          border: 2px solid #194abe;
	          border-radius: 4px;
	          display: flex;
	          justify-content: center;
	          align-items: center;
	          img {
	            width: 16px;
	            height: 16px;
	            margin-right: 7px;
	          }
	          p {
	            font-size: 14px;
	            font-family: Microsoft YaHei;
	            font-weight: 400;
	            line-height: 14px;
	            color: #194abe;
	          }
	        }
	        .form_box_content {
	          width: 100%;
              background:#F9FAFF;
	          .form_title {
	            box-sizing: border-box;
	            text-align: start;
	            display: flex;
	            p {
	              font-size: 16px;
	              font-family: Microsoft YaHei;
	              font-weight: bold;
	              line-height: 20px;
	              color: #0c0d0f;
	            }
	            .delete_icon {
	              cursor: pointer;
	              margin-left: 10px;
	              width: 61px;
	              height: 25px;
	              background: #ffffff;
	              border: 1px solid #f9656f;
	              opacity: 1;
	              border-radius: 6px;
	              display: flex;
	              align-items: center;
	              justify-content: space-evenly;
	              img {
	                width: 13px;
	                height: 14px;
	              }
	              p {
	                font-size: 14px;
	                font-family: Source Han Sans CN;
	                font-weight: 400;
	                line-height: 20px;
	                color: #f9656f;
	              }
	            }
	          }
	        }
	      }
	    }

	.flex {
	    display: flex;
	    align-items: center;
	  }
	  .my_form,
	  .my_form2 {
	    width: 100%;
	    height: 100%;
	    display: flex;
	    overflow: visible;
	    align-items: stretch;
		margin-bottom: 30px;
	    .form_title {
	      width: 80px;
	      min-width: 80px;
	      height: auto;
	      display: flex;
	      justify-content: left;
	      font-size: 14px;
	      font-family: Microsoft YaHei;
	      font-weight: 400;
	      line-height: 20px;
	      box-sizing: border-box;
	      color: #808895;
	    }
	    .form_content,
	    .form_long,
	    .form_content {
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		  width:230px;
	    }
		.form_textarea{
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		}
	  }
      .a01{
          color:#194ABE;
      }
      .a01:hover{
          color:#194ABE;
          text-decoration:underline;
      }
      .a01:visited{
          color:#000;
      }
      .span02{
          font-weight: 400;
          color: #37C8AA;
          margin-left: 5px;
      }
      .span03{
          color: #B0B6C1;
          font-weight: 400;
      }
	  .spanText{
		  margin-top:25px;
		  font-size: 16px;
		  font-family: PingFang SC-Semibold, PingFang SC;
		  font-weight: 600;
		  color: #194ABE;
		  line-height: 0px;
		  -webkit-background-clip: text;
	  }
      .radio01{
          background:#F5F6F7;
          margin-bottom:15px;
          border: none !important;
          width:100px;
          margin-left: 10px;
          margin-right: 10px;
          white-space: nowrap;
          display: inline-block;
          overflow: hidden;
      }
      .pos-page {
      	position: absolute;
      	bottom: 0px !important;
      	width: 100%;
      }
    .infor-t-r {
        width: 104px;
        height: 31px;
        border: 1px solid #7c828a;
        background: #194abe;
        color: #fff;
        border-radius: 5px;
        opacity: 1;
        overflow: hidden;
        display: table-cell;
        line-height: 31px;
        cursor: pointer
    }
    
    .infor-t-r img{
        vertical-align: middle
    }
    
    .infor-t-r span{
        font-size: 14px
    }
    .last_rejection_reason {
        background: #FFF2F3;
        border-radius: 0px 0px 0px 0px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FF6872;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 10px;
        padding:12px;
    }
    .fileerr,.nm_err {
        background: #FFF2F3 !important;
        font-weight: bold  !important;
        font-size: 18px  !important;
        color: #FF6872  !important;
    }
    .gf-reject-opinion {
        font-size: 12px;
        color: #E6A23C;
        padding: 2px 0;
        line-height: 1.5;
    }
    .gf-prev-reject-block {
        background: #fff2f3;
    }
    .gf-prev-reject-block .form_title,
    .gf-prev-reject-block .form_content {
        color: #ff6872 !important;
    }
    .gf-file-link-white {
        color: #ff6872 !important;
    }
    .gf-reject-readonly-input .el-textarea__inner {
        background-color: #fff2f3 !important;
        color: #ff6872 !important;
        border: 1px solid #ffb3b8 !important;
        cursor: not-allowed;
    }
    .warntip {
         font-weight: bold  !important;
        font-size: 14px  !important;
        color: #FF6872  !important;
        margin-top:10px;
        margin-bottom:10px;
        text-align: left;
    }
    .gf-return-hint {
        color: #E51725;
        font-size: 14px;
        line-height: 1.7;
        margin-bottom: 12px;
        text-align: left;
        font-weight: 500;
    }
    .gf-review-table /deep/ .el-table__column-filter-trigger {
        color: #194ABE;
        opacity: 1;
        font-size: 14px;
        margin-left: 4px;
    }
    .gf-review-table /deep/ .el-table__column-filter-trigger .el-icon-arrow-down,
    .gf-review-table /deep/ .el-table__column-filter-trigger .el-icon-arrow-up {
        font-weight: 700;
    }
    .gf-review-table /deep/ .el-table__header-wrapper th.is-leaf .cell {
        font-weight: 600;
    }
    .gf-review-table /deep/ .el-table__column-filter-trigger:hover {
        color: #0F3B9D;
        transform: scale(1.08);
    }
</style>
